// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T22:13:25.773Z
// Property: Chestnut Ridge Apartment Homes (ID: 6767906449166924)
// Collections: 17 amenities, 4 floorplans (live), 23 photos, 75 POIs, 9 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166924",
  "property_external_id": "md0mwej",
  "property_zillow_url": "https://www.zillow.com/apartments/denver-co/chestnut-ridge/5XhvTy/",
  "property_apartments_url": "https://www.apartments.com/chestnut-ridge-apartment-homes-denver-co/md0mwej/",
  "property_google_business_url": "https://www.google.com/maps/place/Chestnut+Ridge+Apartment+Homes/data=!4m2!3m1!1s0x0:0xe2f26167afa87741?sa=X&ved=2ahUKEwjUuNbW6KeSAxULQPUHHRycJeEQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "44672433840",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1124CHNT",
  "property_status": null,
  "property_slug": "chestnut-ridge-apartment-homes",
  "property_name": "Chestnut Ridge Apartment Homes",
  "property_website_url": "https://www.chestnutridgeapthomes.com/",
  "property_domain": "https://www.chestnutridgeapthomes.com/",
  "property_address": "3655 South Verbena Street",
  "property_full_address": "3655 S Verbena St, Denver, CO 80237",
  "property_address_1": "3655 S Verbena St",
  "property_address_2": null,
  "property_address_city": "Denver",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80237",
  "property_address_country": "US",
  "property_address_county": "Denver County",
  "property_neighborhood_address": "Southeast",
  "property_address_latitude": "39.6499127",
  "property_address_longitude": "-104.8932616",
  "property_email": "amc_chestnutridgeapartments_web_propertywebsite@leads.anyonehome.com",
  "property_phone": "(888) 521-9493",
  "property_call_tracking_phone": "888-987-4427",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Chestnut Ridge Apartment Homes in Denver, CO, where modern living meets vibrant comfort. Choose from studio, one, or two-bedroom apartments featuring stainless steel appliances, stunning views, and private patios. Dive into the resort-style pool, stay fit in our 24-hour gym, and enjoy the camaraderie in our stylish clubhouse. Your ideal lifestyle awaits!",
  "property_long_description": "Welcome to Chestnut Ridge Apartment Homes, where luxury living meets unparalleled convenience in the heart of Denver, CO. Our vibrant community features a variety of chic apartment floor plans, including Studio, One-Bedroom, and Two-Bedroom apartments, all designed with your comfort in mind. Experience resort-style living with our stunning amenities, including a sparkling swimming pool, a 24-hour fitness center, and a cozy clubhouse equipped with WiFi, a TV, and a billiard table—perfect for unwinding or entertaining friends.\n\nLocated near light rail access and major highways, Chestnut Ridge ensures effortless commuting to the Denver Tech Center and beyond, making it an ideal home for professionals and families alike. Each apartment boasts high-end finishes, including a stainless steel appliance package, beautiful wood floors in kitchens and bathrooms, and large private patios and decks that offer breathtaking views*—the perfect backdrop for your morning coffee.\n\nIndulge in modern conveniences with in-unit washer and dryers, air conditioning, and stylish ceiling fans. Select units feature vaulted ceilings and heat-circulation fireplaces, providing a warm and inviting atmosphere all year round. Plus, carport spaces and guest parking make hosting friends and family a breeze.\n\nDon’t miss the opportunity to elevate your lifestyle at Chestnut Ridge Apartment Homes. Find your new home today—browse our availability or schedule a tour to visit our beautiful community! Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019f8073-b3b3-76e0-bd36-41754bd8f943.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment community outdoor swimming pool with lounge chairs and tables.",
    "public_id": "019f8073-b3b3-76e0-bd36-41754bd8f943",
    "storage_key": "property/6767906449166924/019f8073-b3b3-76e0-bd36-41754bd8f943.webp",
    "width": 3072,
    "height": 1726
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166924/019f8073-7b88-7027-8181-e478f347bf38.mp4",
  "property_featured_video_media": {
    "public_id": "019f8073-7b88-7027-8181-e478f347bf38",
    "storage_key": "property/6767906449166924/019f8073-7b88-7027-8181-e478f347bf38.mp4",
    "thumbnail_key": "property/6767906449166924/019f8073-7b88-7027-8181-e478f347bf38_thumb.webp",
    "size_bytes": 68769225,
    "classification": "Community",
    "title": "Apartment Community Amenities: Pool & Fitness Center Tour",
    "description": "Explore the fantastic amenities at our apartment community, including a sparkling pool and a fully equipped fitness center. Enjoy a vibrant lifestyle with these excellent facilities."
  },
  "property_total_units": "156",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": "200",
  "property_application_fee": "63.50",
  "property_fees_deposit_info": "Security Deposit\n$750-$1250",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Max 2 pets per household, each up to 80 lbs.",
  "property_pet_policy_description": "We love pets! Cats and dogs allowed. Max 2 pets per household, each up to 80 lbs. Refundable pet deposit: $350. Monthly pet rent: $35.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://resident.payready.com/portal/sign_in",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcchestnutridge",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-3607-73bb-8b85-6916054866e1.webp",
  "property_primary_logo_media": {
    "alt_text": "Chestnut Ridge Apartment Homes logo",
    "public_id": "019d02d5-3607-73bb-8b85-6916054866e1",
    "storage_key": "property/6767906449166924/019d02d5-3607-73bb-8b85-6916054866e1.webp",
    "width": 500,
    "height": 141
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-beb4-716f-80fa-c08d2397f1f3.webp",
  "property_secondary_logo_media": {
    "alt_text": "Chestnut Ridge Apartment Homes logo.",
    "public_id": "019d02d5-beb4-716f-80fa-c08d2397f1f3",
    "storage_key": "property/6767906449166924/019d02d5-beb4-716f-80fa-c08d2397f1f3.webp",
    "width": 640,
    "height": 180
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-cca3-74a7-a0aa-33a32fb7a005.webp",
  "property_icon_media": {
    "alt_text": "CR logo",
    "public_id": "019d02d5-cca3-74a7-a0aa-33a32fb7a005",
    "storage_key": "property/6767906449166924/019d02d5-cca3-74a7-a0aa-33a32fb7a005.webp",
    "width": 80,
    "height": 80
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-cca3-74a7-a0aa-33a32fb7a005.webp",
  "property_fav_icon_media": {
    "alt_text": "CR logo",
    "public_id": "019d02d5-cca3-74a7-a0aa-33a32fb7a005",
    "storage_key": "property/6767906449166924/019d02d5-cca3-74a7-a0aa-33a32fb7a005.webp",
    "width": 80,
    "height": 80
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cb9e-7138-b28c-7c2612f8b4d9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chestnut Ridge Apartment Homes logo",
    "public_id": "019d02d2-cb9e-7138-b28c-7c2612f8b4d9",
    "storage_key": "property/6767906449166924/019d02d2-cb9e-7138-b28c-7c2612f8b4d9.webp",
    "width": 500,
    "height": 141
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-dc88-774a-9dc1-5c6a43638cad.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chestnut Ridge Apartment Homes logo",
    "public_id": "019d02d5-dc88-774a-9dc1-5c6a43638cad",
    "storage_key": "property/6767906449166924/019d02d5-dc88-774a-9dc1-5c6a43638cad.webp",
    "width": 500,
    "height": 141
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#443e57",
  "property_secondary_color": "#5c6cb4",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "657 - 1080",
  "property_sqft_min": "657",
  "property_sqft_max": "1080",
  "property_price_range": null,
  "property_price_min": "1199",
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/ChestnutRidgeApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/chestnutridgecolorado/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmxIeVXWHbIcRQXeor2dh8uI",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Property+Management&find_near=cierra-crest-denver-4&start=120",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chestnut Ridge Apartment Homes",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, choose from inviting studio, one, or two-bedroom layouts tailored for your lifestyle. Enjoy resort-style amenities like our stunning pool, 24-hour fitness center, and cozy clubhouse, all while reveling in spectacular views and convenience to major highways and light rail.",
  "property_home_floorplans_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, you’ll find the ideal backdrop for your lifestyle. Choose from stylish studios, spacious one-bedroom, or expansive two-bedroom apartments. Each floor plan is designed to elevate your living experience. Browse our available homes and uncover the perfect fit today!",
  "property_home_gallery_blurb": "Welcome to Chestnut Ridge Apartment Homes in vibrant Denver, CO, where life meets leisure. Choose from our stylish studio, one, and two-bedroom apartments featuring gourmet kitchens, private patios, and breathtaking views. Enjoy resort-style amenities, including a swimming pool and 24-hour fitness center. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Chestnut Ridge Apartment Homes, where vibrant living meets a rich tapestry of experiences in Denver. Nestled near cultural gems like the Fiddler's Green Amphitheatre and the Museum of Outdoor Arts, our community offers easy access to parks, schools, and thriving local markets. Immerse yourself in the unique energy of your new neighborhood!",
  "property_home_reviews_blurb": "Nestled in tranquil Denver, Chestnut Ridge Apartment Homes offers a serene atmosphere where comfort meets community. Our residents rave about the \"beautiful scenery\" and \"excellent services,\" making it a delightful retreat. With spacious apartments and a dedicated staff, it’s no wonder why many feel their apartment here is a true home.",
  "property_neighborhood_blurb": "At Chestnut Ridge Apartment Homes in Denver, immerse yourself in a vibrant community filled with culture and adventure. From the serenity of Bluff Lake Nature Center to the excitement of Fiddler's Green Amphitheatre, our neighborhood is rich with local gems, parks, and entertainment. Uncover your perfect living environment today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, indulge in a lifestyle of comfort and convenience. Choose from stylish studios to spacious two-bedrooms, each featuring modern amenities. Unwind by the resort-style pool or enjoy wellness at our 24-hour fitness center. Your perfect home awaits—see it today!",
  "property_applynow_blurb": "At Chestnut Ridge Apartment Homes in Denver, discover a lifestyle enriched by stunning views and elegant amenities. Choose from our stylish studio, one, and two-bedroom apartments featuring modern stainless steel appliances, expansive private patios, and a resort-style pool. Embrace convenience and comfort—apply online today for your new home!",
  "property_contactus_blurb": "At Chestnut Ridge Apartment Homes in vibrant Denver, CO, your ideal living space awaits—be it a cozy studio or a spacious two-bedroom. Each floor plan blends modern design with comfort, creating the perfect haven. Have questions? Contact our leasing team today to find your new home!",
  "property_faqs_blurb": "At Chestnut Ridge Apartment Homes in vibrant Denver, CO, discover a variety of floor plans designed for every lifestyle, from cozy studios to spacious two-bedroom apartments. Have questions? Our FAQs page offers insights to help you navigate our inviting community and find your perfect home. Browse now for the answers you need!",
  "property_floorplans_blurb": "At Chestnut Ridge Apartment Homes in the heart of Denver, CO, your ideal living space awaits. Choose from our stylish studio, spacious one-bedroom, or inviting two-bedroom layouts, each designed for comfort and flexibility. Browse our floor plans today and discover the perfect home to complement your lifestyle.",
  "property_gallery_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, envision a lifestyle of comfort and leisure. Choose from our well-appointed studio, one, or two-bedroom apartments featuring modern stainless steel appliances, expansive private patios, and breathtaking views. Relax by the resort-style pool or connect in our vibrant clubhouse—your ideal home awaits!",
  "property_interactivemap_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, choose from stylish studio, one, or two-bedroom layouts designed for modern living. Enjoy resort-style amenities like a sparkling pool, 24-hour fitness center, and inviting clubhouse. With stunning views and easy access to light rail and major highways, your perfect home awaits!",
  "property_pets_blurb": "At Chestnut Ridge Apartment Homes in vibrant Denver, CO, your furry friends are part of the family! With a welcoming atmosphere for cats and dogs—up to 80 lbs each—enjoy a pet-friendly lifestyle. Bring home up to two pets to share in the comfort of your new home!",
  "property_referafriend_blurb": "At Chestnut Ridge Apartment Homes in the heart of Denver, CO, the joy of living is amplified when shared. Choose from cozy studios to spacious two-bedroom layouts, perfect for every lifestyle. Refer a friend today and enjoy the perks of having great neighbors alongside you in our vibrant community!",
  "property_residentaccess_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, your ideal living space awaits—choose from stylish studio, one-bedroom, or spacious two-bedroom floor plans. Already a resident? Seamlessly manage your home via our easy-access portal to pay rent, schedule maintenance, and enjoy a hassle-free lifestyle tailored just for you!",
  "property_reviews_blurb": "At Chestnut Ridge Apartment Homes in Denver, residents revel in a haven of tranquility and warmth. With glowing praise for our dedicated staff—\"They make you feel right at home\"—and spacious, well-maintained apartments, it’s not just a place to live; it's a community where comfort meets convenience. Join us today!",
  "property_created_at": "1763390994590",
  "property_scheduletour_blurb": "At Chestnut Ridge Apartment Homes in Denver, CO, your ideal living space awaits! From spacious studios to charming one- and two-bedroom layouts, our thoughtfully designed floor plans cater to every lifestyle. Curious about the community? Schedule a tour and hear firsthand from our residents about their experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Chestnut Ridge Apartment Homes in vibrant Denver, CO! With floor plans ranging from cozy studios to spacious two-bedrooms, your perfect space awaits. A team member will connect with you soon to help turn your ideal apartment living into a reality. Stay tuned!",
  "property_virtualtours_blurb": "At Chestnut Ridge Apartment Homes in vibrant Denver, CO, find your perfect space with our diverse floor plans—studio, one-bedroom, and two-bedroom options. Experience contemporary living with a virtual tour that showcases our stylish interiors and inviting community. Your new home awaits; see it for yourself today!",
  "property_copyright": "2025 All Rights Reserved. Chestnut Ridge Apartment Homes",
  "property_seo_title_home": "Chestnut Ridge Apartment Homes |  Apartments in Denver, CO",
  "property_seo_description_home": "Experience modern living at Chestnut Ridge in Denver! Enjoy spacious apartments, resort-style amenities, and stunning views. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Denver, CO Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your living at Chestnut Ridge in Denver, CO. From cozy studios to spacious two-bedrooms, find the perfect floor plan that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Denver, CO Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Chestnut Ridge, Denver! Choose stylish studios and one or two-bedroom homes with resort-style amenities and stunning views!",
  "property_seo_title_gallery": "Gallery | Apartments in Denver, CO",
  "property_seo_description_gallery": "Capture life at Chestnut Ridge in Denver! From stunning views to resort-style amenities, picture your perfect home with us. Explore our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Chestnut Ridge Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Chestnut Ridge Apartment Homes! Enjoy virtual tours of our studio, one, and two-bedroom options nestled in vibrant Denver, CO.",
  "property_seo_title_interactivemap": "Interactive Map | Chestnut Ridge Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at Chestnut Ridge, Denver! Explore studios, 1 & 2-bedrooms with great amenities and stunning views on our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Denver, CO",
  "property_seo_description_neighborhood": "Experience the vibrant Denver life at Chestnut Ridge Apartment Homes—uncover local gems and hotspots just steps from your new studio, one, or two-bedroom home!",
  "property_seo_title_contact": "Contact Us | Chestnut Ridge Apartment Homes",
  "property_seo_description_contact": "Connect with Chestnut Ridge Apartment Homes in Denver, CO. Inquire about our studio, one, and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Denver, CO",
  "property_seo_description_faqs": "Find answers to your questions at Chestnut Ridge Apartment Homes in Denver. Enjoy stunning amenities and easy access to highways—your ideal living awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Denver, CO",
  "property_seo_description_reviews": "Experience life at Chestnut Ridge in Denver, CO! Join our vibrant community and see what residents say about resort-style living and stunning amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Denver, CO",
  "property_seo_description_applynow": "Experience Denver living at Chestnut Ridge! Stylish studios to spacious two-bedrooms with resort-style amenities. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Chestnut Ridge Apartment Homes",
  "property_seo_description_residentaccess": "Unlock your Chestnut Ridge community! Manage rent, schedule maintenance, and connect with neighbors in our resident portal. Your Denver home awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Chestnut Ridge Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Chestnut Ridge Apartment Homes in vibrant Denver! Enjoy the perks of great neighbors and a thriving community. Start sharing the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chestnut Ridge Apartment Homes",
  "property_seo_description_scheduletour": "Experience vibrant living at Chestnut Ridge in Denver, CO. Schedule your tour today and see why our community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Chestnut Ridge Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Chestnut Ridge Apartments. Learn how we safeguard your information while you enjoy comfortable living in the heart of Denver.",
  "property_seo_title_accessibility": "Website Accessibility | Chestnut Ridge Apartment Homes",
  "property_seo_description_accessibility": "At Chestnut Ridge Apartment Homes in Denver, we champion digital inclusion. Experience accessibility designed for all, ensuring you feel right at home online.",
  "property_seo_title_sitemap": "Sitemap | Chestnut Ridge Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way through Chestnut Ridge Apartment Homes in Denver, CO! Check out our sitemap for quick access to amenities, floor plans, and community info.",
  "property_seo_title_thankyou": "Thank You | Chestnut Ridge Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Chestnut Ridge in Denver! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Denver, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293567680",
  "amenities": [
    {
      "id": "custom_11ae9e74-d4ca-438d-b195-f5e9f522d8c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Studio, One, and Two‑Bedroom Apartments Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bba2304-0463-4fb9-a7e5-418f70fcf3cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa834588-d74f-4a02-a272-b86fbba81727",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2aa7e090-da9e-4034-91cd-5c7a0a0bf67b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with WiFi, TV, and Billiard Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d016dbf4-7dfa-445a-a23b-399ac89d6531",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location near Light Rail, DTC, and All Major Highways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9618233a-8ae7-4898-bcde-4e4fd7d2ebfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Carport Spaces Available For Rent & Available Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76c04d74-c42c-449c-9e11-eb42cb124ec5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38ba8b88-52b7-4e43-a0c5-1ae7c9611258",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Floors in Kitchen, Bathroom, & Laundry Area",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d1a8e87-4301-4276-867b-18631b9e4e42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Stunning Views*",
      "amount": "false",
      "description": "In select apartment homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69d1f1bf-5b4a-4611-8a32-e5c80e907b31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "In select apartment homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b4875d4-6331-4127-9e7d-0a39e9fc330f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Heat‑Circulation Fireplace",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_062c0b64-1915-4739-97f0-d5d0becd10cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd47ecc2-2c1c-4fdb-8adc-0a11e071072a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_75498de4-c421-4edd-a400-9582c8ed217b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer in every Apartment Home",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2fbc87af-2a33-4709-9efc-06f037b221b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Large Private Patios & Decks",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3175c0b3-6609-481f-94e0-e426f530803a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Units Available For Rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f26f7ac-e26b-4e4f-88d8-32175a336778",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-Friendly Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8f984150-2945-43eb-844d-a3d6601443f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-c558-7598-b934-e4f472856353.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and lush landscaping.",
        "public_id": "019d02d3-c558-7598-b934-e4f472856353",
        "storage_key": "property/6767906449166924/019d02d3-c558-7598-b934-e4f472856353.webp",
        "width": 1163,
        "height": 775
      },
      "title": "Community",
      "description": "The exterior of our apartment buildings features private balconies and is surrounded by beautiful, mature trees and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1b4ccdc-ce96-41e1-988f-7d3a5a47ae02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-88e7-70e4-aa66-155b06b07e44.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured landscaping and a pathway.",
        "public_id": "019d02d4-88e7-70e4-aa66-155b06b07e44",
        "storage_key": "property/6767906449166924/019d02d4-88e7-70e4-aa66-155b06b07e44.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring beautifully maintained grounds and inviting exteriors.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured landscaping and a pathway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77e7b973-fe8b-4629-b6f6-ccc28662fbca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/01a0cf36-1280-7669-aa07-40694124ebe6.webp",
      "image_media": {
        "alt_text": "A young girl lies in the grass, her eyes closed, as a small dog licks her nose.",
        "public_id": "01a0cf36-1280-7669-aa07-40694124ebe6",
        "storage_key": "property/6767906449166924/01a0cf36-1280-7669-aa07-40694124ebe6.webp",
        "width": 1880,
        "height": 1253
      },
      "title": "Lifestyle",
      "description": "Enjoy life's simple pleasures with your furry friend. Our pet-friendly community welcomes your four-legged family members.",
      "link": "",
      "alt_text": "A young girl lies in the grass, her eyes closed, as a small dog licks her nose.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_438e1007-25d7-4a9c-b022-4cc05ed9db96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-88e2-769c-a6e1-2f97ac15371b.webp",
      "image_media": {
        "alt_text": "Apartment complex with large outdoor swimming pool and lounge chairs.",
        "public_id": "019d02d4-88e2-769c-a6e1-2f97ac15371b",
        "storage_key": "property/6767906449166924/019d02d4-88e2-769c-a6e1-2f97ac15371b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our expansive outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Apartment complex with large outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3462f28a-30e7-4ff1-a492-b4f09f0a92db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019f8073-6826-715e-bbbf-29e6beab7dea.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f8073-6826-715e-bbbf-29e6beab7dea",
        "storage_key": "property/6767906449166924/019f8073-6826-715e-bbbf-29e6beab7dea.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and beautiful landscaping. The perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cac79da1-3199-4ffe-a040-70ea2add0e32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019f8073-6a2b-708a-9ab3-f5bb3425b26c.webp",
      "image_media": {
        "alt_text": "Built-in outdoor grill with stone base and trash receptacle.",
        "public_id": "019f8073-6a2b-708a-9ab3-f5bb3425b26c",
        "storage_key": "property/6767906449166924/019f8073-6a2b-708a-9ab3-f5bb3425b26c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's built-in grill station, complete with a stone-encased grill and convenient trash disposal.",
      "link": "",
      "alt_text": "Built-in outdoor grill with stone base and trash receptacle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c603c61c-17a8-4857-a980-72650b270b8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/01a03a05-c9ae-77e8-a0f3-def24128779d.webp",
      "image_media": {
        "alt_text": "A group of young friends enjoying a picnic in a park, toasting with drinks.",
        "public_id": "01a03a05-c9ae-77e8-a0f3-def24128779d",
        "storage_key": "property/6767906449166924/01a03a05-c9ae-77e8-a0f3-def24128779d.webp",
        "width": 1880,
        "height": 1253
      },
      "title": "Lifestyle",
      "description": "Friends gathered for a delightful picnic in a scenic park setting. Enjoy a day filled with laughter, good food, and refreshing drinks amidst nature's beauty.",
      "link": "",
      "alt_text": "A group of young friends enjoying a picnic in a park, toasting with drinks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edcedf17-c57d-4cab-b29a-bef7743ec1af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019f8073-6d2b-716b-a938-8e4f2ec51d6c.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019f8073-6d2b-716b-a938-8e4f2ec51d6c",
        "storage_key": "property/6767906449166924/019f8073-6d2b-716b-a938-8e4f2ec51d6c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring modern cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a57e7d7-4815-47cc-9c3b-22e6ee35e82c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-0ab8-74d9-8245-29b87ae8a650.webp",
      "image_media": {
        "alt_text": "Comfortable seating area in the community lounge with sofas, armchairs, and a coffee table.",
        "public_id": "019d02d5-0ab8-74d9-8245-29b87ae8a650",
        "storage_key": "property/6767906449166924/019d02d5-0ab8-74d9-8245-29b87ae8a650.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring plush seating and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Comfortable seating area in the community lounge with sofas, armchairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_afa4c7eb-db06-4789-a44b-95406118dc00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-0c7c-740a-bf80-e4aa0b77db03.webp",
      "image_media": {
        "alt_text": "Billiard table in a community lounge with fireplace and seating areas.",
        "public_id": "019d02d5-0c7c-740a-bf80-e4aa0b77db03",
        "storage_key": "property/6767906449166924/019d02d5-0c7c-740a-bf80-e4aa0b77db03.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a billiard table, cozy fireplace, and ample seating for residents.",
      "link": "",
      "alt_text": "Billiard table in a community lounge with fireplace and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65b89315-8336-4ef7-bc5d-7d5532966f32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-cbaa-740f-9658-ad2f641c287f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a double sink.",
        "public_id": "019d02d4-cbaa-740f-9658-ad2f641c287f",
        "storage_key": "property/6767906449166924/019d02d4-cbaa-740f-9658-ad2f641c287f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring stainless steel appliances, ample cabinet storage, and a double sink for convenient meal preparation.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8741171a-6b02-4eb7-96f9-b190f9487bf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-ca49-719e-b23a-1533881cd935.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, fireplace, and large abstract art.",
        "public_id": "019d02d4-ca49-719e-b23a-1533881cd935",
        "storage_key": "property/6767906449166924/019d02d4-ca49-719e-b23a-1533881cd935.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a vibrant blue sofa, a cozy fireplace, and elegant decor, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with blue sofa, fireplace, and large abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1c58a4d-2646-4f1c-854d-5374ff904ac6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/01a0cf12-4c9d-70fc-8672-9d0c3c29babb.webp",
      "image_media": {
        "alt_text": "A happy couple with their dog on a couch.",
        "public_id": "01a0cf12-4c9d-70fc-8672-9d0c3c29babb",
        "storage_key": "property/6767906449166924/01a0cf12-4c9d-70fc-8672-9d0c3c29babb.webp",
        "width": 1920,
        "height": 1436
      },
      "title": "Lifestyle",
      "description": "A young couple is relaxing on a couch with their dog, enjoying a cozy moment together.",
      "link": "",
      "alt_text": "A happy couple with their dog on a couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc5bc6b7-e06d-4281-9594-746e0eba4ca4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-bb48-7438-9d43-fd0adb736dd4.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, adjacent to a living space with a desk by the window.",
        "public_id": "019d02d4-bb48-7438-9d43-fd0adb736dd4",
        "storage_key": "property/6767906449166924/019d02d4-bb48-7438-9d43-fd0adb736dd4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfortable living in our thoughtfully designed apartment featuring a dedicated dining area and a bright, versatile living space.",
      "link": "",
      "alt_text": "Dining area with a round table and chairs, adjacent to a living space with a desk by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a1f285b-3464-422f-ae1e-c70b97b991f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-bb3c-73a3-9d70-ce99f5096e9b.webp",
      "image_media": {
        "alt_text": "A furnished bedroom with a queen-size bed, nightstand, and decor.",
        "public_id": "019d02d4-bb3c-73a3-9d70-ce99f5096e9b",
        "storage_key": "property/6767906449166924/019d02d4-bb3c-73a3-9d70-ce99f5096e9b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a comfortable queen-size bed with colorful bedding, a dark wood nightstand with a lamp, and decorative wall art.",
      "link": "",
      "alt_text": "A furnished bedroom with a queen-size bed, nightstand, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fba0738-135a-4bad-9439-04faa2e423da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-bcb2-778a-88e4-a20a63fe9bd7.webp",
      "image_media": {
        "alt_text": "Living room with dining area and breakfast bar",
        "public_id": "019d02d4-bcb2-778a-88e4-a20a63fe9bd7",
        "storage_key": "property/6767906449166924/019d02d4-bcb2-778a-88e4-a20a63fe9bd7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a dining table, breakfast bar, and a comfortable seating area. This open-concept design is perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with dining area and breakfast bar",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_987db7ca-5dcb-47a8-80c5-30eac68cccd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-bb56-714b-bf0e-3146e7abfb71.webp",
      "image_media": {
        "alt_text": "Washer and dryer in apartment laundry closet",
        "public_id": "019d02d4-bb56-714b-bf0e-3146e7abfb71",
        "storage_key": "property/6767906449166924/019d02d4-bb56-714b-bf0e-3146e7abfb71.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Washer and dryer in apartment laundry closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0736750-67bd-406f-9542-b4098ca5aa6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-aa86-767e-8692-d9a1f2e4be2a.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019d02d4-aa86-767e-8692-d9a1f2e4be2a",
        "storage_key": "property/6767906449166924/019d02d4-aa86-767e-8692-d9a1f2e4be2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy this well-appointed bathroom, featuring a spacious vanity, modern toilet, and a relaxing bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e384acf9-adbb-42e6-838c-e67ab4c61713",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-aafa-752d-9007-d83ac948db9b.webp",
      "image_media": {
        "alt_text": "Bedroom with view of hallway and kitchen.",
        "public_id": "019d02d4-aafa-752d-9007-d83ac948db9b",
        "storage_key": "property/6767906449166924/019d02d4-aafa-752d-9007-d83ac948db9b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This apartment bedroom features a comfortable bed, dresser, and a glimpse into the hallway and kitchen area.",
      "link": "",
      "alt_text": "Bedroom with view of hallway and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac400bfa-20c2-4630-ae05-87ee5b1be5ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-9970-73b9-b3d7-b4b1610ff23c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and breakfast bar.",
        "public_id": "019d02d4-9970-73b9-b3d7-b4b1610ff23c",
        "storage_key": "property/6767906449166924/019d02d4-9970-73b9-b3d7-b4b1610ff23c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinetry, and a breakfast bar with stools, perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2185965e-89be-4934-8fac-48438d62b9a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-9824-7268-aec9-4d62933de2a7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, white quartz countertop, and pendant lighting.",
        "public_id": "019d02d4-9824-7268-aec9-4d62933de2a7",
        "storage_key": "property/6767906449166924/019d02d4-9824-7268-aec9-4d62933de2a7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring stainless steel appliances, ample cabinet space, and a sleek quartz countertop, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, white quartz countertop, and pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a7ebc68-1ed6-4fb4-a6e1-e697b1923c78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-5c8b-7648-a02b-d544c0f88420.webp",
      "image_media": {
        "alt_text": "Kitchen island with two bar stools and view of apartment kitchen and closets.",
        "public_id": "019d02d4-5c8b-7648-a02b-d544c0f88420",
        "storage_key": "property/6767906449166924/019d02d4-5c8b-7648-a02b-d544c0f88420.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy casual dining and entertaining at the kitchen island with bar stools. This open-concept design seamlessly connects to the rest of your living space.",
      "link": "",
      "alt_text": "Kitchen island with two bar stools and view of apartment kitchen and closets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c42ab15-d3e4-4ef8-9b49-20d184b6fed4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/01a11d93-6914-77e8-a383-16f1569ee770.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking apartment buildings and parking lot.",
        "public_id": "01a11d93-6914-77e8-a383-16f1569ee770",
        "storage_key": "property/6767906449166924/01a11d93-6914-77e8-a383-16f1569ee770.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with a table and chairs, offering views of the surrounding community and apartment buildings.",
      "link": "",
      "alt_text": "Balcony with table and chairs overlooking apartment buildings and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f16b96ae-91b3-4cb0-aea3-ff725b1a4aa8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Tap & Burger Belleview Station",
      "poi_type": "Restaurants",
      "poi_address": "4910 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "Local beer, gourmet burgers & other modern bar food in slick, roomy digs lined with flat-screens.",
      "poi_long_description": "Local beer, gourmet burgers & other modern bar food in slick, roomy digs lined with flat-screens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-314c-778f-90b6-b257e4b247cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-314c-778f-90b6-b257e4b247cd",
        "storage_key": "property/6767906449166924/019d02d3-314c-778f-90b6-b257e4b247cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tapandburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10224332676147430431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tap--burger-belleview-station",
      "poi_latitude": "39.6252275",
      "poi_longitude": "-104.9067525",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-583-1367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxG526KHbIcRH8Qv62Ug5I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_c7f4ca95-3c5e-4f48-a37d-38622e771ce7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Los Chingones - DTC",
      "poi_type": "Restaurants",
      "poi_address": "4959 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "Edgy, graffiti-splashed Mexican eatery & lounge boasting innovative tacos, cocktails & a patio.",
      "poi_long_description": "Edgy, graffiti-splashed Mexican eatery & lounge boasting innovative tacos, cocktails & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-30fc-710b-926b-cbf46f48dd15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-30fc-710b-926b-cbf46f48dd15",
        "storage_key": "property/6767906449166924/019d02d3-30fc-710b-926b-cbf46f48dd15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.loschingonesmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3309963305068167350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-chingones---dtc",
      "poi_latitude": "39.6246341",
      "poi_longitude": "-104.907238",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-567-4258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35rlnhaHbIcRtoAqyhZa7y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_84a3e9e6-193c-4081-88d9-863e1e627d78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Belleview Beer Garden (BVBG)",
      "poi_type": "Restaurants",
      "poi_address": "6791 E Chenango Ave, Denver, CO 80237, USA",
      "poi_short_description": "Casual outdoor fixture pairing familiar beers and cocktails with a roster of events and a dog park next door.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-50b1-72da-b0c1-b56405b95fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-50b1-72da-b0c1-b56405b95fae",
        "storage_key": "property/6767906449166924/019d02d5-50b1-72da-b0c1-b56405b95fae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.belleviewbeergarden.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14216237650088615834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleview-beer-garden-bvbg",
      "poi_latitude": "39.6256628",
      "poi_longitude": "-104.9072106",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-457e-764e-a827-ec4fa535cd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-457e-764e-a827-ec4fa535cd86",
        "storage_key": "property/6767906449166924/019d02d4-457e-764e-a827-ec4fa535cd86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq-OOEQaHbIcRmt8QaNI4SsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_53927ead-2475-4f92-a0b7-bb2a1f50e242",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Le French DTC Belleview Station",
      "poi_type": "Restaurants",
      "poi_address": "4901 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "Spacious, informal restaurant with outdoor seating crafting traditional French dishes & pastries.",
      "poi_long_description": "Spacious, informal restaurant with outdoor seating crafting traditional French dishes & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-3117-7528-9983-fb1d2184e8b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-3117-7528-9983-fb1d2184e8b6",
        "storage_key": "property/6767906449166924/019d02d3-3117-7528-9983-fb1d2184e8b6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://lefrenchdenver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16565561720915260575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "le-french-dtc-belleview-station",
      "poi_latitude": "39.6252573",
      "poi_longitude": "-104.9071118",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-710-8963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrc12stWHbIcRn3T2952y5OU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_03d16b6b-5a68-453b-afde-46ea28862cc8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Corvus Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "4925 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "Artisanal coffee roastery & cafe offering espresso drinks & more in a stylish, industrial space.",
      "poi_long_description": "Artisanal coffee roastery & cafe offering espresso drinks & more in a stylish, industrial space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-3118-758e-8cb3-1afbd946fe00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-3118-758e-8cb3-1afbd946fe00",
        "storage_key": "property/6767906449166924/019d02d3-3118-758e-8cb3-1afbd946fe00.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.corvuscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878378991578924367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corvus-coffee-roasters",
      "poi_latitude": "39.6249888",
      "poi_longitude": "-104.9071442",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-458-0943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a954-705f-9100-a4a0bb53339e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a954-705f-9100-a4a0bb53339e",
        "storage_key": "property/6767906449166924/019d02d3-a954-705f-9100-a4a0bb53339e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWw-hrOOGbIcRT0Vm8STF0jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_ae0cb3a5-a3b9-46eb-b492-f5c10afef85a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Yampa Sandwich Co.",
      "poi_type": "Restaurants",
      "poi_address": "4919 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "Local deli chain serving gourmet sandwiches, including breakfast options, in a casual setting.",
      "poi_long_description": "Local deli chain serving gourmet sandwiches, including breakfast options, in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-3ac8-7448-98f7-333841b0a286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-3ac8-7448-98f7-333841b0a286",
        "storage_key": "property/6767906449166924/019d02d3-3ac8-7448-98f7-333841b0a286.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://yampasandwichco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5937569335782478319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yampa-sandwich-co",
      "poi_latitude": "39.6250804",
      "poi_longitude": "-104.9071679",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-927-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRnwnhaHbIcR7xGRMNp7ZlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_435ae6b4-9c7e-4068-b673-96993beddee6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Peckish",
      "poi_type": "Restaurants",
      "poi_address": "4920 S Newport St, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-3ae3-749b-bc82-8dd1ea41b850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-3ae3-749b-bc82-8dd1ea41b850",
        "storage_key": "property/6767906449166924/019d02d3-3ae3-749b-bc82-8dd1ea41b850.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.peckishco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=683979532587762262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peckish",
      "poi_latitude": "39.6250772",
      "poi_longitude": "-104.9067408",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-248-3764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUce-faHbIcRVgKI0cL7fQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0463a457-573c-4685-b61b-657d63703083",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Crisp and Green",
      "poi_type": "Restaurants",
      "poi_address": "6821 E Chenango Ave, Denver, CO 80237, USA",
      "poi_short_description": "Counter-serve restaurant specializing in made-to-order salads, grain bowls, and smoothies in a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5496-7758-ba46-9f128f7d9bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5496-7758-ba46-9f128f7d9bd8",
        "storage_key": "property/6767906449166924/019d02d5-5496-7758-ba46-9f128f7d9bd8.webp",
        "width": 736,
        "height": 518
      },
      "poi_business_url": "https://crispandgreen.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=11174616867240813550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crisp-and-green",
      "poi_latitude": "39.6256604",
      "poi_longitude": "-104.9063502",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-955-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-UDVlSHbIcR7iP6yNU2FJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1d4ab8f9-7e95-4d49-9fae-3dcf1a5452bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Playa Bowls",
      "poi_type": "Restaurants",
      "poi_address": "4852 S Newport St Unit D, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-54f7-72e1-a0f4-726cdf4c5df6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-54f7-72e1-a0f4-726cdf4c5df6",
        "storage_key": "property/6767906449166924/019d02d5-54f7-72e1-a0f4-726cdf4c5df6.webp",
        "width": 954,
        "height": 1280
      },
      "poi_business_url": "https://www.playabowls.com/location/belleview-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7684856609147807325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playa-bowls",
      "poi_latitude": "39.626311",
      "poi_longitude": "-104.9066764",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-993-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5_jCQeHbIcRXWYRsl4Ypmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_310c0862-e443-4d40-b168-92f194ff2bc4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Ambli Global - DTC",
      "poi_type": "Restaurants",
      "poi_address": "6799 E Belleview Ave, Denver, CO 80237, USA",
      "poi_short_description": "Creative small plates with global flair & craft cocktails are the highlights at this modern eatery.",
      "poi_long_description": "Creative small plates with global flair & craft cocktails are the highlights at this modern eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-39f7-73a9-9ce6-b1c3c4665e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-39f7-73a9-9ce6-b1c3c4665e6a",
        "storage_key": "property/6767906449166924/019d02d3-39f7-73a9-9ce6-b1c3c4665e6a.webp",
        "width": 678,
        "height": 381
      },
      "poi_business_url": "https://www.amblidenver.com/ambliglobalatbelleviewstation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15676172924674779599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ambli-global---dtc",
      "poi_latitude": "39.6244508",
      "poi_longitude": "-104.9071353",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-476-3164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aH3z-OGbIcRzynWFDj0jNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_4677dff9-d956-42c2-a2b7-bf33ea134317",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Ruth's Chris Steak House",
      "poi_type": "Restaurants",
      "poi_address": "7001 E Belleview Ave #100, Denver, CO 80237, USA",
      "poi_short_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_long_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-3636-7016-bf8b-9433a05117c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-3636-7016-bf8b-9433a05117c2",
        "storage_key": "property/6767906449166924/019d02d3-3636-7016-bf8b-9433a05117c2.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "https://www.ruthschris.com/locations/co/denver-tech/denver-tech/7362?cmpid=br:rc_ag:ie_ch:loc_ca:RCGMB_sn:gmb_gt:denver-co-7362_pl:locurl_rd:1062",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700035006145662675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruths-chris-steak-house",
      "poi_latitude": "39.62439",
      "poi_longitude": "-104.9044177",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-854-9304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xoiN-OGbIcR044q8nFynYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4d3e162-e2bd-4a67-8499-994e8dc63012",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Saverina",
      "poi_type": "Restaurants",
      "poi_address": "6985 E Chenango Ave, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-35c6-746a-90cf-2502187a4d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-35c6-746a-90cf-2502187a4d22",
        "storage_key": "property/6767906449166924/019d02d3-35c6-746a-90cf-2502187a4d22.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "https://saverinadenver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5639249981452408555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saverina",
      "poi_latitude": "39.6257018",
      "poi_longitude": "-104.905627",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-546-7866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y-F5uKGbIcR61YZ6PqjQk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_24bdd508-4cf7-4a9f-841b-3ca86dd01e94",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Halo Rooftop Bar",
      "poi_type": "Restaurants",
      "poi_address": "6985 E Chenango Ave, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5879-73cf-b617-f0a09d08f03a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5879-73cf-b617-f0a09d08f03a",
        "storage_key": "property/6767906449166924/019d02d5-5879-73cf-b617-f0a09d08f03a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://halobardenver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076651723508961368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halo-rooftop-bar",
      "poi_latitude": "39.6257018",
      "poi_longitude": "-104.905627",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 983-999-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-457e-764e-a827-ec4fa535cd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-457e-764e-a827-ec4fa535cd86",
        "storage_key": "property/6767906449166924/019d02d4-457e-764e-a827-ec4fa535cd86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y-F5uKGbIcRWFD0bb2_0Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_61c99a7d-211e-4a8f-8303-56bca64744e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Tai Tai Japanese",
      "poi_type": "Restaurants",
      "poi_address": "5078 E Hampden Ave, Denver, CO 80222, USA",
      "poi_short_description": "Casual sushi joint with delivery featuring hand rolls, poke bowls, sashimi and a chef's selection tasting menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5a51-745f-acad-f26937d33609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5a51-745f-acad-f26937d33609",
        "storage_key": "property/6767906449166924/019d02d5-5a51-745f-acad-f26937d33609.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://taitaijapanese.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11905551800150357951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tai-tai-japanese",
      "poi_latitude": "39.652784",
      "poi_longitude": "-104.9280289",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-287-4321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSmavjaHbIcRv3f5rkgEOaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_d6656c15-6ad2-42c7-904a-79777197c22c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Birdcall",
      "poi_type": "Restaurants",
      "poi_address": "4996 E Hampden Ave, Denver, CO 80222, USA",
      "poi_short_description": "Fast-food chain serving up all-natural chicken sandwiches, salads, and tater tots in a casual space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5b98-70dd-bde8-f694877354a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5b98-70dd-bde8-f694877354a6",
        "storage_key": "property/6767906449166924/019d02d5-5b98-70dd-bde8-f694877354a6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://eatbirdcall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2860634422016656865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdcall",
      "poi_latitude": "39.652651",
      "poi_longitude": "-104.928871",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-799-8911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a958-71e7-bfc3-75c8c7b7d56d",
        "storage_key": "property/6767906449166924/019d02d3-a958-71e7-bfc3-75c8c7b7d56d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eROdv6HbIcR4cWOvNkDsyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5ba25ee7-268b-4497-9e11-d62748f788c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "6470 E Hampden Ave, Denver, CO 80222, USA",
      "poi_short_description": "Supermarket stocking organic produce and dairy, plus a bakery, butcher and deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-4037-72bb-8727-63dc7b286401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-4037-72bb-8727-63dc7b286401",
        "storage_key": "property/6767906449166924/019d02d3-4037-72bb-8727-63dc7b286401.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/denver/southmoor/620/00026?cid=loc_62000026_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4157755036943469214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "39.6518597",
      "poi_longitude": "-104.9141829",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-758-1210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a954-705f-9100-abfe6b4f33ed",
        "storage_key": "property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8wPDmWmHbIcRnkobaC1Qszk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a6a1208b-d9c4-4799-a086-ef9807c4a757",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "4351 S Tamarac Pkwy, Denver, CO 80237, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-4d4c-73df-964d-90b2abb9629c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-4d4c-73df-964d-90b2abb9629c",
        "storage_key": "property/6767906449166924/019d02d3-4d4c-73df-964d-90b2abb9629c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/denver/4351-s-tamarac-pkwy-39504?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3292560643892619192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.637586",
      "poi_longitude": "-104.8952023",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-220-1404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aef7-7088-8bd8-05b3be4baf4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aef7-7088-8bd8-05b3be4baf4c",
        "storage_key": "property/6767906449166924/019d02d3-aef7-7088-8bd8-05b3be4baf4c.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJMxDtcpd8z4cRuKem_HWGsS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7f10c34a-266b-46be-873c-697126e5700e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "7950 E Hampden Ave, Denver, CO 80231, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5f2e-7458-83ea-826b133b1307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5f2e-7458-83ea-826b133b1307",
        "storage_key": "property/6767906449166924/019d02d5-5f2e-7458-83ea-826b133b1307.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/denver-co-pharmacies/7950-e-hampden-avenue-denver-co-80237/storeid=10831?WT.mc_id=LS_GOOGLE_FS_10831",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387836641335810135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.6527689",
      "poi_longitude": "-104.8992229",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-600-1468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbfI7SGHbIcRV5inGuFwxUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_0206a305-25ba-4f3c-94d7-49237846b3ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 E Hampden Ave Unit D, Denver, CO 80231, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-5f36-724d-99db-fe78c10aecb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-5f36-724d-99db-fe78c10aecb1",
        "storage_key": "property/6767906449166924/019d02d5-5f36-724d-99db-fe78c10aecb1.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/tamarac?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2401647277010190830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.6521655",
      "poi_longitude": "-104.9019875",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-488-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a954-705f-9100-abfe6b4f33ed",
        "storage_key": "property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEauwzXOHbIcR7gH6VXldVCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1d70e24f-73be-4bd7-95fd-1294939120f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1442 S Parker Rd, Denver, CO 80231, USA",
      "poi_short_description": "Neighborhood grocery store offering organic produce and other items, plus pickup and delivery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-60ba-763c-80d7-89f0e8ecbe2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-60ba-763c-80d7-89f0e8ecbe2e",
        "storage_key": "property/6767906449166924/019d02d5-60ba-763c-80d7-89f0e8ecbe2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3128-denver-co?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9729170247450470701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "39.6902165",
      "poi_longitude": "-104.8888835",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-481-0182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a954-705f-9100-abfe6b4f33ed",
        "storage_key": "property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkaZL0XR9bIcRLamV7sr0BIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_91790d96-cd90-45ee-8d02-a9f2b13bc08e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7777 E Hampden Ave, Denver, CO 80231, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-4541-727c-9f33-7aecedc9dfad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-4541-727c-9f33-7aecedc9dfad",
        "storage_key": "property/6767906449166924/019d02d3-4541-727c-9f33-7aecedc9dfad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/denver-se/2820",
      "poi_directions_map_url": "https://maps.google.com/?cid=6124336535288922418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.6549517",
      "poi_longitude": "-104.9002075",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-481-2821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a950-74e3-b8bb-5de9615005d2",
        "storage_key": "property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG6qMb3GHbIcRMsHXdqED_lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c807b2f2-b1c7-4b16-91cf-1af68e42a979",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Ace Hardware of Tamarac Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "3333 S Tamarac Dr, Denver, CO 80231, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-49cf-744e-9f15-df6ba03fa2ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-49cf-744e-9f15-df6ba03fa2ce",
        "storage_key": "property/6767906449166924/019d02d3-49cf-744e-9f15-df6ba03fa2ce.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.acehardware.com/store-details/08484",
      "poi_directions_map_url": "https://maps.google.com/?cid=14077525849795017479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ace-hardware-of-tamarac-square",
      "poi_latitude": "39.6562972",
      "poi_longitude": "-104.9009034",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-751-7225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a950-74e3-b8bb-5de9615005d2",
        "storage_key": "property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ1NDVXCHbIcRBztpqSxrXcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_f5342251-ea5f-49eb-8954-fd12e8dfd485",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Belleview Promenade",
      "poi_type": "Shopping & Retail",
      "poi_address": "8000 E Belleview Ave, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Compact mall with shops, eateries & selected services ranging from dentists to hair salons.",
      "poi_long_description": "Compact mall with shops, eateries & selected services ranging from dentists to hair salons.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-6602-75ab-bab4-446da2b20552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-6602-75ab-bab4-446da2b20552",
        "storage_key": "property/6767906449166924/019d02d5-6602-75ab-bab4-446da2b20552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8949443967073741534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleview-promenade",
      "poi_latitude": "39.6225831",
      "poi_longitude": "-104.8962181",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-528-6317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a950-74e3-b8bb-5de9615005d2",
        "storage_key": "property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2fCJTPmGbIcR3mqxMt_PMnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fc30d041-58d3-4798-9cb9-a5b12d19ccc6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "The Landmark",
      "poi_type": "Shopping & Retail",
      "poi_address": "7600 Landmark Way, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-65c1-7139-ad61-7aa9bba4d520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-65c1-7139-ad61-7aa9bba4d520",
        "storage_key": "property/6767906449166924/019d02d5-65c1-7139-ad61-7aa9bba4d520.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://visitthelandmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4619664053426308540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-landmark",
      "poi_latitude": "39.6175063",
      "poi_longitude": "-104.900062",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-545-5455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxvrZPCGbIcRvMUdBvtXHEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "condominium_complex"
    },
    {
      "id": "custom_760b6cbb-ebab-4320-a205-f102832b5a9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8557 E Arapahoe Rd B, Greenwood Village, CO 80112, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-65af-7658-8380-d5a5fc8ee292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-65af-7658-8380-d5a5fc8ee292",
        "storage_key": "property/6767906449166924/019d02d5-65af-7658-8380-d5a5fc8ee292.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sprouts.com/store/co/greenwood-village/greenwood-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=4094340229338076010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "39.596189",
      "poi_longitude": "-104.890586",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-721-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a954-705f-9100-abfe6b4f33ed",
        "storage_key": "property/6767906449166924/019d02d3-a954-705f-9100-abfe6b4f33ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYyemX2GbIcRapNJ774E0jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_916843a0-5710-41f2-a2a6-c637b804daa0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Fisher Early Learning Center",
      "poi_type": "Education",
      "poi_address": "1899 E Evans Ave, Denver, CO 80210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7257-7113-a938-ed523c3b4444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7257-7113-a938-ed523c3b4444",
        "storage_key": "property/6767906449166924/019d02d5-7257-7113-a938-ed523c3b4444.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.du.edu/fisher/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15075759170317774022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fisher-early-learning-center",
      "poi_latitude": "39.6789371",
      "poi_longitude": "-104.9654725",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-871-2723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyQeUBz9-bIcRxuwgMhfbN9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b2c2e308-d7c0-4cde-ad3e-f7b2e25e52c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Iliff Preschool, Kindergarten and School-Age Summer Camp",
      "poi_type": "Education",
      "poi_address": "4140 E Iliff Ave, Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7257-7113-a938-e90d3f877611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7257-7113-a938-e90d3f877611",
        "storage_key": "property/6767906449166924/019d02d5-7257-7113-a938-e90d3f877611.webp",
        "width": 1209,
        "height": 906
      },
      "poi_business_url": "https://iliffpreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=204191146871637226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iliff-preschool-kindergarten-and-school-age-summer-camp",
      "poi_latitude": "39.6746363",
      "poi_longitude": "-104.9387179",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-757-3551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2WupqeJ9bIcR6kSQJ8Ru1QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_eaceb1b7-049a-489c-b731-59ebffd39117",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Primrose School at Colorado Station",
      "poi_type": "Education",
      "poi_address": "4300 E Warren Ave, Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7386-74b0-a6ef-61a22bea4b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7386-74b0-a6ef-61a22bea4b47",
        "storage_key": "property/6767906449166924/019d02d5-7386-74b0-a6ef-61a22bea4b47.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/colorado-station/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16658068587916952209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-at-colorado-station",
      "poi_latitude": "39.6760149",
      "poi_longitude": "-104.9375814",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-757-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuepyjeJ9bIcRkQLiWh9ZLec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_1478c06c-4c7b-47b9-b217-617d5ebefacb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Denver Academy",
      "poi_type": "Education",
      "poi_address": "4400 E Iliff Ave, Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7638-756c-9c0e-2c63a04078b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7638-756c-9c0e-2c63a04078b3",
        "storage_key": "property/6767906449166924/019d02d5-7638-756c-9c0e-2c63a04078b3.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://www.denveracademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13638396645027124495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-academy",
      "poi_latitude": "39.6736237",
      "poi_longitude": "-104.9344147",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-777-5870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ92MAel5-bIcRD5W4RH1RRb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c137191a-2d68-43f9-ae35-61d51a114fa2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Fiddler's Green Amphitheatre",
      "poi_type": "Entertainment",
      "poi_address": "6350 Greenwood Plaza Blvd, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Massive amphitheater with seating, grassy slopes & mountain views featuring acclaimed music artists.",
      "poi_long_description": "Massive amphitheater with seating, grassy slopes & mountain views featuring acclaimed music artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-56c3-74c9-aef3-6f0e82ec03ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-56c3-74c9-aef3-6f0e82ec03ec",
        "storage_key": "property/6767906449166924/019d02d3-56c3-74c9-aef3-6f0e82ec03ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fiddlersgreenamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13818850404477874076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fiddlers-green-amphitheatre",
      "poi_latitude": "39.6006062",
      "poi_longitude": "-104.8940083",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-220-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZ2mWoiGbIcRnK8qOzprxr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_8021bf37-cd19-4024-a9a5-62d4ea640344",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Museum of Outdoor Arts",
      "poi_type": "Entertainment",
      "poi_address": "6331 S Fiddlers Green Cir, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Sophisticated venue offers modern art exhibitions, an outdoor sculpture garden & education programs.",
      "poi_long_description": "Sophisticated venue offers modern art exhibitions, an outdoor sculpture garden & education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-5b62-736b-90a6-3ba109c73643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-5b62-736b-90a6-3ba109c73643",
        "storage_key": "property/6767906449166924/019d02d3-5b62-736b-90a6-3ba109c73643.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://moaonline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859190246263805300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-outdoor-arts",
      "poi_latitude": "39.6020522",
      "poi_longitude": "-104.8932659",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-806-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b45d-7279-ace8-8d1c6699349f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b45d-7279-ace8-8d1c6699349f",
        "storage_key": "property/6767906449166924/019d02d3-b45d-7279-ace8-8d1c6699349f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwIeyYmGbIcRdNVg-y-9MF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c72ba768-eb6d-431d-ab4c-9a9c0d438a44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Regal River Point",
      "poi_type": "Entertainment",
      "poi_address": "3565 S Platte River Dr, Sheridan, CO 80110, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-79fb-76ce-8834-7bc6f05938a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-79fb-76ce-8834-7bc6f05938a3",
        "storage_key": "property/6767906449166924/019d02d5-79fb-76ce-8834-7bc6f05938a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-river-point-1943?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6879590462168189012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-river-point",
      "poi_latitude": "39.652626",
      "poi_longitude": "-105.008644",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b45a-747d-93ab-c9e988e26ab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b45a-747d-93ab-c9e988e26ab8",
        "storage_key": "property/6767906449166924/019d02d3-b45a-747d-93ab-c9e988e26ab8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ40tUAqAbIcRVEizYRM3eV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fdee43c2-459e-4e6f-b700-f165e99bc374",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "The Landmark at Greenwood Village",
      "poi_type": "Entertainment",
      "poi_address": "5415 Landmark Pl, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_long_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-5736-707f-9f0f-2b8dbf65c090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-5736-707f-9f0f-2b8dbf65c090",
        "storage_key": "property/6767906449166924/019d02d3-5736-707f-9f0f-2b8dbf65c090.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "https://www.landmarktheatres.com/denver/greenwood-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=5336219926827186479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-landmark-at-greenwood-village",
      "poi_latitude": "39.61832520000001",
      "poi_longitude": "-104.9011879",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-779-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b45a-747d-93ab-c9e988e26ab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b45a-747d-93ab-c9e988e26ab8",
        "storage_key": "property/6767906449166924/019d02d3-b45a-747d-93ab-c9e988e26ab8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJdcXiyUGHbIcRLznlPcAPDko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2761c696-c27b-4fa9-b245-5fbbcc5c6adc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Denver Performing Arts Complex",
      "poi_type": "Entertainment",
      "poi_address": "1400 Curtis Street, Denver, CO 80204, USA",
      "poi_short_description": "Large center featuring 10 performance spaces for plays, concerts & other events, plus restaurants.",
      "poi_long_description": "Large center featuring 10 performance spaces for plays, concerts & other events, plus restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7a51-7094-b6d6-87373fa2b29d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7a51-7094-b6d6-87373fa2b29d",
        "storage_key": "property/6767906449166924/019d02d5-7a51-7094-b6d6-87373fa2b29d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://artscomplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11781947137153973533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-performing-arts-complex",
      "poi_latitude": "39.7445062",
      "poi_longitude": "-104.9981874",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 720-865-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_vG1dF4bIcRHT1-cH_igaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_35a4a6db-4ab8-477d-b94f-cf49ce5a3913",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "The Mission Ballroom",
      "poi_type": "Entertainment",
      "poi_address": "4242 Wynkoop St, Denver, CO 80216, USA",
      "poi_short_description": "Current artists perform on a moving stage that can be adapted to varying audience sizes.",
      "poi_long_description": "Current artists perform on a moving stage that can be adapted to varying audience sizes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7b56-730e-a73e-5ad033a94c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7b56-730e-a73e-5ad033a94c0d",
        "storage_key": "property/6767906449166924/019d02d5-7b56-730e-a73e-5ad033a94c0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.missionballroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13246821525312496917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mission-ballroom",
      "poi_latitude": "39.776204",
      "poi_longitude": "-104.969168",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 720-577-6884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzlf3X95bIcRFeU_G_4p1rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_272a2a04-db6e-4cbe-92e8-7bb6f9897ea9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Paramount Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1621 Glenarm Pl, Denver, CO 80202, USA",
      "poi_short_description": "This 1930 art deco performance space hosts live entertainment from concerts to comedians.",
      "poi_long_description": "This 1930 art deco performance space hosts live entertainment from concerts to comedians.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-7c04-76ee-8fc7-e80659d5e03a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-7c04-76ee-8fc7-e80659d5e03a",
        "storage_key": "property/6767906449166924/019d02d5-7c04-76ee-8fc7-e80659d5e03a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.paramountdenver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17433849078538945510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paramount-theatre",
      "poi_latitude": "39.7443051",
      "poi_longitude": "-104.9900913",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 303-623-0106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93pnwdZ4bIcR5sMVUl558fE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_116af012-bac7-447f-8a54-c20b1ea93bab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Bluebird Theater",
      "poi_type": "Entertainment",
      "poi_address": "3317 E Colfax Ave, Denver, CO 80206, USA",
      "poi_short_description": "National & local acts take the stage at this City Park music venue with an old-school feel.",
      "poi_long_description": "National & local acts take the stage at this City Park music venue with an old-school feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8043-700d-851c-e4376caa5d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8043-700d-851c-e4376caa5d3d",
        "storage_key": "property/6767906449166924/019d02d5-8043-700d-851c-e4376caa5d3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluebirdtheater.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14193728540762651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluebird-theater",
      "poi_latitude": "39.7403305",
      "poi_longitude": "-104.9483906",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 303-377-1666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8d_pa1-bIcRG-K18x5tMgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_dc952925-1b79-4247-b0df-d686ea633ac7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Downtown Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "700 Water St, Denver, CO 80211, USA",
      "poi_short_description": "Sprawling complex with a state-of-the-art aquarium housing 500+ species, plus a restaurant & lounge.",
      "poi_long_description": "Sprawling complex with a state-of-the-art aquarium housing 500+ species, plus a restaurant & lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8091-77ae-9fac-4ba424996db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8091-77ae-9fac-4ba424996db2",
        "storage_key": "property/6767906449166924/019d02d5-8091-77ae-9fac-4ba424996db2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.downtownaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5731122937697157734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-aquarium",
      "poi_latitude": "39.7518486",
      "poi_longitude": "-105.0140113",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-561-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YNrYr54bIcRZkKIcfIJiU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_e30bedcc-eb23-4f71-90bc-413210f99038",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Children's Museum of Denver at Marsico Campus",
      "poi_type": "Entertainment",
      "poi_address": "2121 Children's Museum Dr, Denver, CO 80211, USA",
      "poi_short_description": "An old fire truck, bubble-blowing lab & other interactive exhibits help kids learn by participating.",
      "poi_long_description": "An old fire truck, bubble-blowing lab & other interactive exhibits help kids learn by participating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8192-72dc-9cfd-815fd5ae487a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8192-72dc-9cfd-815fd5ae487a",
        "storage_key": "property/6767906449166924/019d02d5-8192-72dc-9cfd-815fd5ae487a.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://www.mychildsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13865368703228205308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-denver-at-marsico-campus",
      "poi_latitude": "39.7486272",
      "poi_longitude": "-105.0169778",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 303-433-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b45d-7279-ace8-8d1c6699349f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b45d-7279-ace8-8d1c6699349f",
        "storage_key": "property/6767906449166924/019d02d3-b45d-7279-ace8-8d1c6699349f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzj7kbt4bIcR_Fi8q1-va8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_df5a3041-6e9c-4d8e-b162-64d96ef30b69",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "HCA HealthONE Swedish",
      "poi_type": "Health and Wellness",
      "poi_address": "501 E Hampden Ave, Englewood, CO 80113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-95d8-7081-9525-ad845ab82094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-95d8-7081-9525-ad845ab82094",
        "storage_key": "property/6767906449166924/019d02d3-95d8-7081-9525-ad845ab82094.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.healthonecares.com/locations/swedish?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11855944775002216283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthone-swedish",
      "poi_latitude": "39.6538817",
      "poi_longitude": "-104.980537",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-788-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b6df-72db-a654-9a269e5a524b",
        "storage_key": "property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyd6eR4GAbIcRW9enFvXGiKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1a6bc7ef-20b9-44f3-932e-663000f44336",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "AdventHealth ER & Urgent Care Southmoor",
      "poi_type": "Health and Wellness",
      "poi_address": "7000 E Hampden Ave, Denver, CO 80224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8537-74f7-98c7-eca56c3382d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8537-74f7-98c7-eca56c3382d6",
        "storage_key": "property/6767906449166924/019d02d5-8537-74f7-98c7-eca56c3382d6.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.adventhealth.com/emergency-room/adventhealth-er-urgent-care-southmoor",
      "poi_directions_map_url": "https://maps.google.com/?cid=10977510029231785156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-er--urgent-care-southmoor",
      "poi_latitude": "39.6527137",
      "poi_longitude": "-104.9081344",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-925-4199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdGwquSHbIcRxASm0jXzV5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_3964aeb9-5e45-4e74-8ba0-c725e4688fa0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "HCA HealthONE Division",
      "poi_type": "Health and Wellness",
      "poi_address": "4900 S Monaco St, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://healthonecares.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14348739412368783164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthone-division",
      "poi_latitude": "39.6260444",
      "poi_longitude": "-104.9108076",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-788-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3equFx6HbIcRPHfjAHn2IMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fe25544b-e341-4fb8-b754-c08c4eac69ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "King Soopers Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "890 S Monaco St Pkwy, Denver, CO 80224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-86d4-7698-bc55-aaf3b761206d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-86d4-7698-bc55-aaf3b761206d",
        "storage_key": "property/6767906449166924/019d02d5-86d4-7698-bc55-aaf3b761206d.webp",
        "width": 1044,
        "height": 587
      },
      "poi_business_url": "https://www.kingsoopers.com/rx/pharmacy/details/620/00035?cid=loc_62000035P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17903415447379736752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers-pharmacy",
      "poi_latitude": "39.7007899",
      "poi_longitude": "-104.9111858",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-333-1545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af01-70e4-ba31-3d1afcd1fa88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af01-70e4-ba31-3d1afcd1fa88",
        "storage_key": "property/6767906449166924/019d02d3-af01-70e4-ba31-3d1afcd1fa88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUJK_7Z9bIcRsHhPN361dfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_54dca14b-bb1f-4869-a1db-8a7a7aa01b96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Walgreens Specialty Pharmacy at Swedish Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "499 E Hampden Ave Ste 150, Englewood, CO 80113, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-6fc5-703e-ae1e-ce6945b618c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-6fc5-703e-ae1e-ce6945b618c4",
        "storage_key": "property/6767906449166924/019d02d3-6fc5-703e-ae1e-ce6945b618c4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-499+e+hampden+ave-englewood-co-80113/id=12805",
      "poi_directions_map_url": "https://maps.google.com/?cid=14924629109648730468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy-at-swedish-medical-center",
      "poi_latitude": "39.6536104",
      "poi_longitude": "-104.9821031",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-524-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af01-70e4-ba31-3d1afcd1fa88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af01-70e4-ba31-3d1afcd1fa88",
        "storage_key": "property/6767906449166924/019d02d3-af01-70e4-ba31-3d1afcd1fa88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb-wL4GAbIcRZCkR5RnvHs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3a9f848a-d3f6-4be3-8f08-194de687d8e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Colorado Athletic Club DTC",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 DTC Pkwy, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Athletic club in the Denver Tech Center offering fitness classes for adults, teens, and kids, as well as personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-87cb-72cb-8c0b-ef5f64d788f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-87cb-72cb-8c0b-ef5f64d788f3",
        "storage_key": "property/6767906449166924/019d02d5-87cb-72cb-8c0b-ef5f64d788f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wellbridge.com/colorado-athletic-club-dtc/?utm_source=rl&utm_medium=organic&utm_campaign=dtc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798217376724351302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-athletic-club-dtc",
      "poi_latitude": "39.6167012",
      "poi_longitude": "-104.8964093",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-779-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1iWGPeGbIcRRvmKha8eWF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_38c4d3c4-16cf-4b36-93b6-89362d278795",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6770 E Chenango Ave, Denver, CO 80237, USA",
      "poi_short_description": "Gym chain offering heart rate-based exercise sessions that mix cardio and strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-75eb-7043-a8b2-1d75d33f337d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-75eb-7043-a8b2-1d75d33f337d",
        "storage_key": "property/6767906449166924/019d02d3-75eb-7043-a8b2-1d75d33f337d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/denver-colorado-0558?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=1073037818952923496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.62520689999999",
      "poi_longitude": "-104.9074442",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-504-1015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNaGSTuKGbIcRaLk_DTYy5A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d741fe60-3cf0-42f9-9ab0-7eede37fb4d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "CYCLEBAR",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 Landmark Way Ste A201, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Cycling classes at a gym featuring themed rides and classes for all fitness levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8ac0-7463-91d6-28f20deb22ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8ac0-7463-91d6-28f20deb22ad",
        "storage_key": "property/6767906449166924/019d02d5-8ac0-7463-91d6-28f20deb22ad.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://cyclebar.com/location/denver-tech-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=8375204396347924397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyclebar",
      "poi_latitude": "39.617441",
      "poi_longitude": "-104.8999233",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-927-6889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9AYlPCGbIcRrZ-bVQa0OnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e3d2c1b3-9e6f-4bab-91f0-a59165dcd3f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "CorePower Yoga - DTC",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 Landmark Way Suite 201, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8c64-72f8-9d26-982901f7f8d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8c64-72f8-9d26-982901f7f8d1",
        "storage_key": "property/6767906449166924/019d02d5-8c64-72f8-9d26-982901f7f8d1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5807560447346089719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---dtc",
      "poi_latitude": "39.6174377",
      "poi_longitude": "-104.9000483",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdxYHmHCHbIcR9x6sA3WZmFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_8b9a467b-bd75-436b-9075-8b3f9dd6a40a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Hampden Run Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3501 S Uravan St, Aurora, CO 80013, USA",
      "poi_short_description": "Kid-friendly space with swings and slides, and a music-making area including a xylophone.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8d5c-728d-9b26-685dca9f27e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8d5c-728d-9b26-685dca9f27e2",
        "storage_key": "property/6767906449166924/019d02d5-8d5c-728d-9b26-685dca9f27e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/park_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247212705589267140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampden-run-park",
      "poi_latitude": "39.6527393",
      "poi_longitude": "-104.7781657",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-739-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUJD_aKJbIcRxIpkqwy0Lx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0d138315-9f57-49ac-841b-d113c3fa112f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Horseshoe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2125 S Kittredge Way, Aurora, CO 80013, USA",
      "poi_short_description": "A creek & trails run through this narrow 10-mile park with a horseshoe shape & baseball diamonds.",
      "poi_long_description": "A creek & trails run through this narrow 10-mile park with a horseshoe shape & baseball diamonds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-8fc6-756d-a036-263ee433f110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-8fc6-756d-a036-263ee433f110",
        "storage_key": "property/6767906449166924/019d02d5-8fc6-756d-a036-263ee433f110.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/cms/One.aspx?portalId=1881221&pageId=2037935",
      "poi_directions_map_url": "https://maps.google.com/?cid=16114633835121062336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horseshoe-park",
      "poi_latitude": "39.6806473",
      "poi_longitude": "-104.8002298",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-739-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2ySJ9WJbIcRwLHhExiuot8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ade2453c-7cc6-4347-bb48-9459e9c779a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Horizon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3901 S Reservoir Rd, Aurora, CO 80013, USA",
      "poi_short_description": "Park featuring a tennis court, along with a middle school.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9209-71f1-af7c-8f762f992cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9209-71f1-af7c-8f762f992cf7",
        "storage_key": "property/6767906449166924/019d02d5-9209-71f1-af7c-8f762f992cf7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=544402643904549948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horizon-park",
      "poi_latitude": "39.6428485",
      "poi_longitude": "-104.7728781",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-739-7213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6--VQHWJbIcRPNS2_FEbjgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fcf7fa8c-4983-4d08-a88d-050035f497ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Grandview Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17500 E Quincy Ave, Aurora, CO 80015, USA",
      "poi_short_description": "Off-leash park featuring a fenced area for smaller dogs, plus agility courses.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9550-778c-8af5-6b49004bd584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9550-778c-8af5-6b49004bd584",
        "storage_key": "property/6767906449166924/019d02d5-9550-778c-8af5-6b49004bd584.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/dog_parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=7948878972229039990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grandview-dog-park",
      "poi_latitude": "39.6371817",
      "poi_longitude": "-104.7841055",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-739-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10NVFw-JbIcRdrdIbk8XUG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_baf8382c-d456-4fd1-aedb-b3513c3de238",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Plains Conservation Center (Visitor Center)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "21901 E Hampden Ave, Aurora, CO 80013, USA",
      "poi_short_description": "Natural area with a reconstructed prairie homestead & Cheyenne camp, hiking trails & public events.",
      "poi_long_description": "Natural area with a reconstructed prairie homestead & Cheyenne camp, hiking trails & public events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9481-75f9-8393-217ffa0a7211.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9481-75f9-8393-217ffa0a7211",
        "storage_key": "property/6767906449166924/019d02d5-9481-75f9-8393-217ffa0a7211.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/nature___open_space/nature_centers/plains_conservation_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2749334225572632268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plains-conservation-center-visitor-center",
      "poi_latitude": "39.6560284",
      "poi_longitude": "-104.737023",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 303-326-8380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcWNXjSKbIcRzJYUXOmYJyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_be42f45f-2a71-4c5a-ae85-2c1a20aef585",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Sunburst Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 S Memphis St, Aurora, CO 80015, USA",
      "poi_short_description": "Cheerful community park with play equipment, a picnic shelter & a grass field, plus restrooms.",
      "poi_long_description": "Cheerful community park with play equipment, a picnic shelter & a grass field, plus restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9744-73a8-bb60-938ec4668487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9744-73a8-bb60-938ec4668487",
        "storage_key": "property/6767906449166924/019d02d5-9744-73a8-bb60-938ec4668487.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/park_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=342314282702209599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunburst-park",
      "poi_latitude": "39.6363294",
      "poi_longitude": "-104.7990158",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-739-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZaB_P2IbIcRPwICxgYlwAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_311c8fa3-afc5-474a-af25-cde07c9aa96d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Mission Viejo Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3999 S Mission Pkwy, Aurora, CO 80013, USA",
      "poi_short_description": "Spacious green area offering several baseball fields, a playground & 3 picnic shelters.",
      "poi_long_description": "Spacious green area offering several baseball fields, a playground & 3 picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9802-765f-a52b-eec1a9dc4779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9802-765f-a52b-eec1a9dc4779",
        "storage_key": "property/6767906449166924/019d02d5-9802-765f-a52b-eec1a9dc4779.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.auroragov.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3747588406815774368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-viejo-park",
      "poi_latitude": "39.646436",
      "poi_longitude": "-104.7975539",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-739-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1jeXquJbIcRoFag6MwbAjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_250180be-923a-46d8-94da-ee123a988dac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Jewell Wetlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13005 E Jewell Ave, Aurora, CO 80012, USA",
      "poi_short_description": "A habitat for diverse wildlife, this conservation area offers trails & a butterfly garden.",
      "poi_long_description": "A habitat for diverse wildlife, this conservation area offers trails & a butterfly garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9c78-7710-95d5-dca94be268e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9c78-7710-95d5-dca94be268e7",
        "storage_key": "property/6767906449166924/019d02d5-9c78-7710-95d5-dca94be268e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/park_listing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7468041942697313004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jewell-wetlands-park",
      "poi_latitude": "39.6843927",
      "poi_longitude": "-104.8345175",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-739-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1rvbq9ibIcR7AIxWpTQo2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f67cbd64-770e-488b-97af-062838a8345c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Bluff Lake Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11255 E M.L.K. Jr Blvd, Denver, CO 80238, USA",
      "poi_short_description": "Walk-friendly place popular for wildlife viewing, plus a scenic lake and educational events for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9e59-751f-bbef-8c7d6f3772d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9e59-751f-bbef-8c7d6f3772d9",
        "storage_key": "property/6767906449166924/019d02d5-9e59-751f-bbef-8c7d6f3772d9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.blufflake.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14712246050935728952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluff-lake-nature-center",
      "poi_latitude": "39.7581832",
      "poi_longitude": "-104.8567415",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 720-708-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b53e-77b3-9645-609e578068db",
        "storage_key": "property/6767906449166924/019d02d3-b53e-77b3-9645-609e578068db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVbl8bIcROOsqotVlLMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_d8f68fcf-71d1-4e0c-8c6d-463f05892bbe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "RTD - Southmoor Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3737 S Monaco St Pkwy, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-9da6-7051-8817-69e97ea9ce7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-9da6-7051-8817-69e97ea9ce7d",
        "storage_key": "property/6767906449166924/019d02d5-9da6-7051-8817-69e97ea9ce7d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rtd-denver.com/rider-info/how-to-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14930428111190213875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rtd---southmoor-station-park--ride",
      "poi_latitude": "39.6486558",
      "poi_longitude": "-104.9143373",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-292-1505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-ba24-75a2-b918-ae45ecd763b4",
        "storage_key": "property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_9BLdkN-bIcR88T_J0OJM88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_b63f0240-0325-412e-a440-eec7b8b8c964",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Belleview Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-3185-77dd-af90-e92f47d3dd6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3185-77dd-af90-e92f47d3dd6a",
        "storage_key": "property/6767906449166924/019d02d4-3185-77dd-af90-e92f47d3dd6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtd-denver.com/belleview-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=411848644852892074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleview-station",
      "poi_latitude": "39.6276318",
      "poi_longitude": "-104.9044568",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2LMpeKGbIcRqsGuESkutwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4cbbd1db-fca8-4c8b-ade1-7ed9ac99b829",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Dayton Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-a07a-7042-bcbe-05cc007ec618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-a07a-7042-bcbe-05cc007ec618",
        "storage_key": "property/6767906449166924/019d02d5-a07a-7042-bcbe-05cc007ec618.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4425420376454213024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dayton-station",
      "poi_latitude": "39.6441339",
      "poi_longitude": "-104.8793684",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-ba24-75a2-b918-ae45ecd763b4",
        "storage_key": "property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTobykyGbIcRoC1UsGJAaj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c2c739d3-adf0-4603-bf9d-2a3d45fb780e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "RTD Yale Station Park-N-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "5201E E Yale Cir, Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-a2e2-709a-8333-9dceb88c5894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-a2e2-709a-8333-9dceb88c5894",
        "storage_key": "property/6767906449166924/019d02d5-a2e2-709a-8333-9dceb88c5894.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.rtd-denver.com/HowToPark.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=5644261375627078913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rtd-yale-station-park-n-ride",
      "poi_latitude": "39.6692706",
      "poi_longitude": "-104.9278226",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-292-1505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-ba24-75a2-b918-ae45ecd763b4",
        "storage_key": "property/6767906449166924/019d02d3-ba24-75a2-b918-ae45ecd763b4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJta1G5vl9bIcRAa21CdFxVE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_261b89c6-509c-4fb0-ae1b-ec88461523d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Orchard Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5652 Greenwood Plaza Blvd, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-8e9d-753a-8590-75057cdc8fc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-8e9d-753a-8590-75057cdc8fc8",
        "storage_key": "property/6767906449166924/019d02d3-8e9d-753a-8590-75057cdc8fc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtd-denver.com/orchard-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=5377936209269536797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orchard-station",
      "poi_latitude": "39.6135639",
      "poi_longitude": "-104.8962089",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3qUVPGGbIcRHbg4In1Eoko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3d98c126-3ff5-468b-b24a-bdef0878511d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Hampden Ave & S Verbena St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80231, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3804008070688088272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampden-ave--s-verbena-st",
      "poi_latitude": "39.653201",
      "poi_longitude": "-104.892203",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1z4iXWHbIcR0CAVkC-NyjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_361b3daa-522b-4612-b91e-2761f76b3b08",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "S Monaco Pkwy & Hampden Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14168379412075938294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-monaco-pkwy--hampden-ave",
      "poi_latitude": "39.65414699999999",
      "poi_longitude": "-104.913068",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEXbormmHbIcR9oG-CwIyoMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a5948e26-0a25-4432-9ae5-8bf9f4955b7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Denver International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8500 Peña Blvd, Denver, CO 80249, USA",
      "poi_short_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_long_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-a556-7769-95fc-8ebb67a1cd5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-a556-7769-95fc-8ebb67a1cd5e",
        "storage_key": "property/6767906449166924/019d02d5-a556-7769-95fc-8ebb67a1cd5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flydenver.com/?utm_source=google&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5285039807900523626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-international-airport",
      "poi_latitude": "39.8563486",
      "poi_longitude": "-104.6764061",
      "poi_miles_from_property": "25.9",
      "poi_walking_minutes": "9 hours 30 mins",
      "poi_biking_minutes": "2 hours 34 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 720-730-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-ba40-75fb-a049-05336506b3a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-ba40-75fb-a049-05336506b3a4",
        "storage_key": "property/6767906449166924/019d02d3-ba40-75fb-a049-05336506b3a4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0T_mCp_bIcRapy1NbQ7WEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_11a7a6d5-477b-4450-ab49-2a752dcc64b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Cafe One",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5251 DTC Pkwy, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Basic venue for breakfast & lunch in a modern granite-clad office building.",
      "poi_long_description": "Basic venue for breakfast & lunch in a modern granite-clad office building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-a5d6-70af-a4c9-7d8373b5db15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-a5d6-70af-a4c9-7d8373b5db15",
        "storage_key": "property/6767906449166924/019d02d5-a5d6-70af-a4c9-7d8373b5db15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.onedtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090805413550305021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-one",
      "poi_latitude": "39.6203002",
      "poi_longitude": "-104.8982664",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-770-9997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-a950-74e3-b8bb-5de9615005d2",
        "storage_key": "property/6767906449166924/019d02d3-a950-74e3-b8bb-5de9615005d2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYTGNGPqGbIcR_S79__i8Lu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_20b46e64-ca1c-4785-99ef-1a7b11a9d4f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "University of Colorado Anschutz",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13001 E 17th Pl, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-a23b-712c-80ed-8a6511abfe9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a23b-712c-80ed-8a6511abfe9c",
        "storage_key": "property/6767906449166924/019d02d3-a23b-712c-80ed-8a6511abfe9c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cuanschutz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9364229194661812447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-anschutz",
      "poi_latitude": "39.7455133",
      "poi_longitude": "-104.8375984",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-724-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGXo4rk5jbIcR39got9Zs9IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0b662269-c6e5-4ccb-bfd5-b8039a66ee71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "UCHealth Anschutz Outpatient Pavilion - Anschutz Medical Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1635 Aurora Ct, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d5-a8d8-73ec-9b2f-aa5f82b7df3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-a8d8-73ec-9b2f-aa5f82b7df3a",
        "storage_key": "property/6767906449166924/019d02d5-a8d8-73ec-9b2f-aa5f82b7df3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-anschutz-outpatient-pavilion/?utm_source=GMBSocialClimb&utm_medium=UCHealthAnschutzOutpatientPavilion-AnschutzMedicalCampus",
      "poi_directions_map_url": "https://maps.google.com/?cid=10658853702885697754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-anschutz-outpatient-pavilion---anschutz-medical-campus",
      "poi_latitude": "39.7422394",
      "poi_longitude": "-104.8401144",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-848-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b6df-72db-a654-9a269e5a524b",
        "storage_key": "property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcuM5EtjbIcR2uhbQfja65M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d60815ab-a656-4028-bed2-f7a28c0c8276",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Craig Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3425 S Clarkson St, Englewood, CO 80113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-9aab-74ff-9cfe-9fac58912b8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9aab-74ff-9cfe-9fac58912b8a",
        "storage_key": "property/6767906449166924/019d02d3-9aab-74ff-9cfe-9fac58912b8a.webp",
        "width": 1280,
        "height": 563
      },
      "poi_business_url": "https://craighospital.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18163940045450682206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "craig-hospital",
      "poi_latitude": "39.6542457",
      "poi_longitude": "-104.9787712",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-789-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-b6df-72db-a654-9a269e5a524b",
        "storage_key": "property/6767906449166924/019d02d3-b6df-72db-a654-9a269e5a524b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwMX7IOAbIcRXp-UEjxHE_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_83f482aa-b169-430f-a4cc-a041619e0e5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Dish Network",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 S Meridian Blvd, Englewood, CO 80112, USA",
      "poi_short_description": "Chain providing satellite communication services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-9b75-7777-b775-e9c4ed76ec8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9b75-7777-b775-e9c4ed76ec8c",
        "storage_key": "property/6767906449166924/019d02d3-9b75-7777-b775-e9c4ed76ec8c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dish.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4892674684427030581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dish-network",
      "poi_latitude": "39.54598",
      "poi_longitude": "-104.856233",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-333-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoU-0FIyFbIcRNdDR9rNF5kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c00fa51d-83d8-4b1b-9b8f-ccef39ac06db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Arrow Electronics Panorama",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9151 E Panorama Cir, Centennial, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d4-3aac-7619-9277-8148f6090926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3aac-7619-9277-8148f6090926",
        "storage_key": "property/6767906449166924/019d02d4-3aac-7619-9277-8148f6090926.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.arrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12590639283718182594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arrow-electronics-panorama",
      "poi_latitude": "39.5799363",
      "poi_longitude": "-104.8821225",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-824-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52Kt3c-FbIcRwtYZcbjvuq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_546bdeab-475f-48a3-b53a-45c7b674095f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Recon Logistics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "384 Inverness Pkwy, Englewood, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://reconlogistics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4331039751132913129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "recon-logistics",
      "poi_latitude": "39.563626",
      "poi_longitude": "-104.8649176",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 866-424-7153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-aeff-724e-bf28-067409767857",
        "storage_key": "property/6767906449166924/019d02d3-aeff-724e-bf28-067409767857.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1wxE5eFbIcR6Z1f8rTxGjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_044f0414-266f-459a-a8f8-bb51a6a449c7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Samuels Elementary School",
      "poi_type": "Education",
      "poi_address": "3985 S Vincennes Ct, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://samuels.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13015201159297092372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "samuels-elementary-school",
      "poi_latitude": "39.6427776",
      "poi_longitude": "-104.8917106",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-424-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY_Nj2AmHbIcRFMsnNH9In7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fa348ae5-5a1f-40ff-b932-dac92ac47b09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Hamilton Middle School",
      "poi_type": "Education",
      "poi_address": "8600 E Dartmouth Ave, Denver, CO 80231, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hamilton.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2720599728238781447&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hamilton-middle-school",
      "poi_latitude": "39.65992869999999",
      "poi_longitude": "-104.8920755",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-423-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6e1YOdOHbIcRB2Sy2QmDwSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_dd57ee23-5a90-4d53-ac5f-b8314fd76a11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "custom",
      "poi_name": "Thomas Jefferson High School",
      "poi_type": "Education",
      "poi_address": "3950 S Holly St, Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019f1e99-74f1-7659-8ceb-16195c92110b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1e99-74f1-7659-8ceb-16195c92110b",
        "storage_key": "property/6767906449166924/019f1e99-74f1-7659-8ceb-16195c92110b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tjhs.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13951227715310445711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thomas-jefferson-high-school",
      "poi_latitude": "39.6469327",
      "poi_longitude": "-104.9213055",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-423-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d3-af30-7208-a50f-c21d512bf664",
        "storage_key": "property/6767906449166924/019d02d3-af30-7208-a50f-c21d512bf664.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFdjuxUCHbIcRj-Spt7C3nME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_636cebec3c293241505ffaf3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c6ca9791833cde291270ece0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f01ca998fc72f2f69397b3e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_26cb89fdc2f1564f549e19fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_78e87295312935eb9d0ee826",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_34fdd87fb417dc276843b1d3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "day": "SAT",
      "open_time": "13:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5d5186a1-ae71-4092-be06-bc0ac1ca1c5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5.0",
      "name": "Tyreik Shorty",
      "text": "Chestnut Ridge is a wonderful place to live the maintenance members, the neighbors are great individuals, always working always willing to lend a hand. To our super stars Joe and Orlando best maintenance department  too Liz and August in the leasing office makes every interaction warm & home welcoming, great staff really makes you feel part of the family. Thanks for a wonderful five years!",
      "date": "2025-11-13",
      "title": ""
    },
    {
      "id": "custom_8570ae0a-881e-4c31-9ba6-0a393756d41e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5.0",
      "name": "Gaby A",
      "text": "Love living here♥️ Absolutely all thanks to JOE!! This man asked me to take a chance w Chestnut Ridge and im glad I did! The apartment is great, peaceful community, kind neighbors and the amenities are all awesome! Joe and Orlando do an absolute great job in keeping up w the property and GO ABOVE AND BEYOND!👏",
      "date": "2025-11-16",
      "title": ""
    },
    {
      "id": "custom_33cdfde8-0520-4373-b7c1-39593bfe667c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": " Kathryn Toberman",
      "text": "The maintenance team here is awesome! Plus they like my dog!",
      "date": "2026-10-01",
      "title": "false"
    },
    {
      "id": "custom_b5702caf-108b-4558-8e7c-71b60df78f8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": "Zion Schwartz",
      "text": "My partner and I have been living here for about a year and so far it’s been amazing under new management. John and Orlando have been wonderful at responding to maintenance requests and have been extremely helpful throughout the process of getting things fixed up and advocating for more up to date appliances.",
      "date": "2026-09-17",
      "title": "false"
    },
    {
      "id": "custom_2df54e29-4235-49d7-97e3-aaac9d995fcb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": " Tatum Comer",
      "text": "We've really enjoyed our 1st year here and the new management has been great at making changes/renovations/ quickly responding to maintenance. John and Orlando are super respectful when they come in your apartment and friendly faces on the grounds. Very quick to respond to requests and ask for feedback. Appreciate the team.\n",
      "date": "2026-09-02",
      "title": "false"
    },
    {
      "id": "custom_663fb1ea-c3a4-49eb-9c39-2676eaa4f311",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": "Wayne Allan",
      "text": "Love how quiet it is here and the maintenance staff if amazing at responding and fixing any problem we have. Thank you John and Orlando\n",
      "date": "2026-09-01",
      "title": "false"
    },
    {
      "id": "custom_3fb36e09-bf60-481d-86db-ac8435f86050",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "4",
      "name": " Aurora Williams",
      "text": "Very happy here! This has been a great complex to live at. Lorena in the leasing office has been amazing. Very communicative and always willing to help. I have had a few issues with my apartment and John and Orlando on the maintenance team have been awesome. Very quick to get in and very kind.\n",
      "date": "2026-09-01",
      "title": "false"
    },
    {
      "id": "custom_29cdd8d0-3ff9-40c1-90cc-b33445bd5554",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": " Sidney Kile",
      "text": "Lorena my leasing agent is so friendly and sweet. I love her energy.\n",
      "date": "2026-07-03",
      "title": "false"
    },
    {
      "id": "custom_51ee79fd-1f7b-4686-a99f-87f654ef9c22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "rating": "5",
      "name": "Brenda Lopez",
      "text": "The chillest vibes you’ll get living here, literally can hear the birds singing in the mornings. Lorena, My leasing agent helped make the move go smoothly, even the last min things. Always quick with responses and solutions. Lovely & welcoming staff.\n",
      "date": "2026-07-03",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ab72e-76b3-7335-b5ca-94f4f2afba1c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-chestnut-ridge-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-denver-co-chestnut-ridge",
      "search_query": "apartments with in-unit laundry Denver CO",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Denver, CO",
      "h2_subtitle": "Experience the convenience of in-unit laundry at Chestnut Ridge Apartment Homes. Live comfortably in Denver, CO, with all modern amenities at your fingertips.",
      "page_copy": "Chestnut Ridge Apartment Homes in Denver, CO, offers the ultimate comfort in urban living with apartments featuring in-unit laundry. Our beautifully designed studio, one, and two-bedroom layouts ensure you have all the conveniences of modern living, including the ease of doing laundry right in your apartment. The contemporary stainless steel appliance package and wood floors add a touch of elegance to your daily routine.\n\nNestled in the vibrant Southeast neighborhood, our community not only provides the convenience of in-unit laundry but also pampers you with a resort-style pool, a fully equipped 24-hour gym, and a chic clubhouse perfect for social gatherings. Enjoy private patios with stunning views and the availability of carport spaces. Choose Chestnut Ridge for a lifestyle where comfort meets functionality right here in Denver.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Denver, CO",
      "seo_description": "Discover Chestnut Ridge Apartments in Denver, CO, offering in-unit laundry and modern amenities. Live comfortably with us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-southeast-denver-chestnut-ridge",
      "search_query": "24 hour fitness center apartments Southeast Denver",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center Apartments in SE Denver",
      "h2_subtitle": "Chestnut Ridge Apartment Homes offers a state-of-the-art 24-hour fitness center. Stay active any time of day in Southeast Denver.",
      "page_copy": "Welcome to Chestnut Ridge Apartment Homes, where you can enjoy 24-hour access to our state-of-the-art fitness center. Our Southeast Denver location not only offers modern studio, one, and two-bedroom apartments but also ensures that residents can maintain their fitness routines at any time of day. The fitness center features a wide range of equipment, perfect for cardio and strength training.\n\nLiving at Chestnut Ridge means embracing a lifestyle full of convenience and luxury. Alongside the 24-hour fitness center, you’ll find amenities like a resort-style pool and a stylish clubhouse for relaxation and socializing. Each apartment is equipped with stainless steel appliances, wood floors, and private patios that boast stunning views. Dive into a lifestyle where fitness and modern living converge perfectly in Denver.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness Center Apartments in SE Denver",
      "seo_description": "Find your ideal home with a 24-hour fitness center at Chestnut Ridge Apartments in Southeast Denver. Modern living with fitness anytime!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-with-resort-style-pool-denver-80237-chestnut-ridge",
      "search_query": "apartments with resort-style pool Denver 80237",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in Denver 80237",
      "h2_subtitle": "Enjoy a refreshing lifestyle at Chestnut Ridge, where a resort-style pool awaits. Dive into luxury living in Denver's 80237 area.",
      "page_copy": "Nestled in the vibrant community of Denver 80237, Chestnut Ridge Apartment Homes offers an unparalleled living experience with a striking resort-style pool as one of its signature amenities. Ideal for relaxation or social gatherings, the pool provides a perfect escape on those sun-filled Colorado days. \n\nThis urban haven features modern studio, one, and two-bedroom apartments equipped with sleek stainless steel appliances, wood flooring, and private patios that display breathtaking views. Additional amenities include a 24-hour gym and a stylish clubhouse, designed to enhance the living experiences of our residents. Embrace the resort lifestyle in one of Southeast Denver’s most sought-after communities and make Chestnut Ridge your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Denver 80237",
      "seo_description": "Live luxuriously at Chestnut Ridge Apartments in Denver 80237, featuring a resort-style pool and modern amenities. Dive into comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "stainless-steel-appliances-apartments-near-dtc-chestnut-ridge",
      "search_query": "stainless steel appliances apartments near DTC",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances Near DTC",
      "h2_subtitle": "Discover modern living with stainless steel appliances at Chestnut Ridge. Experience comfort and style near the Denver Tech Center (DTC).",
      "page_copy": "Chestnut Ridge Apartment Homes, located conveniently near the Denver Tech Center (DTC), offers apartments equipped with sleek stainless steel appliances. Our studio, one, and two-bedroom layouts are designed to combine elegance with functionality, making them ideal for professionals and families alike. \n\nIn addition to modern kitchen amenities, our community features luxurious touches such as wood flooring in key areas, private patios for breathtaking views, and a resort-style pool. Enjoy easy access to work and play with our proximity to DTC, while relishing the comfort of home with on-site perks like a 24-hour fitness center and carport parking. Choose Chestnut Ridge for a lifestyle that's both sophisticated and convenient in the vibrant Southeast Denver area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stainless Steel Appliances Apartments Near DTC",
      "seo_description": "Find stylish living at Chestnut Ridge Apartments near DTC, featuring modern amenities like stainless steel appliances and more. Perfect for professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "large-private-patios-apartment-homes-denver-county-chestnut-ridge",
      "search_query": "large private patios apartment homes Denver County",
      "category": "Amenity",
      "h1_title": "Apartment Homes with Large Private Patios in Denver",
      "h2_subtitle": "Relax in spacious comfort at Chestnut Ridge with our large private patios. Experience the best of Denver County living.",
      "page_copy": "At Chestnut Ridge Apartment Homes, we pride ourselves on offering residences with large private patios that provide an expansive extension of your living space. Situated in the heart of Denver County, our community caters to those who appreciate outdoor leisure and scenic views from the privacy of their own apartment. \n\nOur deluxe studio, one, and two-bedroom apartments are not only equipped with these generous patios but also include features like stainless steel appliances and wood flooring. The community also boasts a resort-style pool, a 24-hour fitness center, and a stylish clubhouse for socializing. Experience a harmonious blend of indoor and outdoor living in one of Denver’s most sought-after neighborhoods at Chestnut Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes with Large Patios in Denver",
      "seo_description": "Discover Denver County living at Chestnut Ridge Apartments, offering large private patios and luxury amenities for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "studio-apartments-southeast-denver-chestnut-ridge",
      "search_query": "studio apartments southeast denver",
      "category": "Floorplan",
      "h1_title": "Modern Studio Apartments in Southeast Denver",
      "h2_subtitle": "Explore stylish studio apartments at Chestnut Ridge, located in the vibrant Southeast Denver area, offering comfort and convenience.",
      "page_copy": "Chestnut Ridge Apartment Homes in Southeast Denver offers sophisticated studio apartments tailored for a modern lifestyle. These thoughtfully designed spaces feature sleek stainless steel appliances and wood flooring, creating an ideal setting for your home. \n\nOur community provides more than just a place to live; enjoy access to a resort-style pool, a 24-hour gym for keeping fit, and a chic clubhouse perfect for meeting neighbors or hosting friends. Located in one of Denver's most lively and dynamic areas, Chestnut Ridge ensures both comfort and convenience, making it an exceptional choice for anyone seeking a studio apartment in Southeast Denver.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Studio Apartments in Southeast Denver",
      "seo_description": "Find your ideal studio apartment at Chestnut Ridge in Southeast Denver. Enjoy modern amenities and a vibrant lifestyle. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-denver-co-chestnut-ridge",
      "search_query": "1 bedroom apartments in denver co",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Denver, CO",
      "h2_subtitle": "Experience the comfort of spacious 1 bedroom apartments at Chestnut Ridge in Denver, CO, designed for modern living.",
      "page_copy": "Discover the perfect blend of comfort and style with our 1 bedroom apartments at Chestnut Ridge Apartment Homes, located in the vibrant heart of Denver, CO. Our spacious units feature top-tier amenities including stainless steel appliances, wood flooring, and the luxury of vaulted ceilings in select units. \n\nBeyond the walls of your new home, enjoy a thriving community atmosphere with access to a resort-style pool, a fully-equipped 24-hour fitness center, and a welcoming clubhouse. Nestled conveniently in Southeast Denver, you’re just minutes away from local attractions and the bustling city life, making Chestnut Ridge the ideal place for those seeking both adventure and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Denver, CO",
      "seo_description": "Explore stylish 1 bedroom apartments in Denver, CO, at Chestnut Ridge, offering modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-80237-chestnut-ridge",
      "search_query": "2 bedroom apts 80237 area",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apts in the 80237 Area",
      "h2_subtitle": "Discover the ideal space with our 2 bedroom apts at Chestnut Ridge, perfectly located in Denver's 80237 area.",
      "page_copy": "Chestnut Ridge Apartment Homes offers spacious 2 bedroom apartments in the vibrant 80237 area of Denver, designed to enhance your living experience. Each unit is equipped with premium stainless steel appliances, ensuring a modern and functional kitchen space, while wood floors add a touch of elegance to the kitchen, bathroom, and laundry areas.\n\nResidents enjoy access to exceptional amenities, including a resort-style pool for relaxation, a 24-hour gym catering to all fitness needs, and a stylish clubhouse perfect for social gatherings. Located in the Southeast neighborhood, Chestnut Ridge is surrounded by natural beauty and urban convenience, making it an ideal choice for families, professionals, and everyone in between looking for a home in the 80237 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts in the 80237 Area",
      "seo_description": "Explore spacious 2 bedroom apts in Denver's 80237 area at Chestnut Ridge. Enjoy modern amenities and serene surroundings. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-university-park-elementary-denver",
      "search_query": "apartments near University Park Elementary School Denver",
      "category": "School",
      "h1_title": "Apartments Near University Park Elementary",
      "h2_subtitle": "Discover convenient living at Chestnut Ridge, offering apartments near University Park Elementary School in Denver.",
      "page_copy": "Located just a short distance from University Park Elementary School in Denver, Chestnut Ridge Apartment Homes provide the ideal location for families seeking high-quality education and vibrant community living. Choose from studio, one, or two-bedroom floor plans featuring premium amenities like stainless steel appliances and private patios.\n\nOur community is designed for both comfort and convenience, with access to a luxurious resort-style pool and a 24-hour fitness center. Enjoy the family-friendly environment of our stylish clubhouse and take advantage of the nearby Southeast Denver neighborhood, known for its excellent schools and parks. Experience the perfect blend of accessibility and serenity at Chestnut Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Park Elementary, Denver",
      "seo_description": "Find family-friendly apartments near University Park Elementary in Denver at Chestnut Ridge, offering modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-close-to-cory-elementary-southeast-denver",
      "search_query": "apartments close to Cory Elementary School Southeast Denver",
      "category": "School",
      "h1_title": "Apartments Close to Cory Elementary School",
      "h2_subtitle": "Find ideal living at Chestnut Ridge, featuring apartments close to Cory Elementary School in Southeast Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes offers a prime location for families, with apartments conveniently close to Cory Elementary School in Southeast Denver. Our community provides a variety of living spaces including studio, one, and two-bedroom apartments, all equipped with modern amenities such as stainless steel appliances and wooden floors.\n\nEnjoy the perfect blend of family-friendly living and modern conveniences with amenities like a resort-style pool and a 24-hour gym. Located in a thriving neighborhood, you’ll find Chestnut Ridge is a perfect choice for anyone looking to be near quality education and vibrant community activities. Discover comfort and convenience at Chestnut Ridge, where home feels just right.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cory Elementary in Southeast Denver",
      "seo_description": "Explore apartments near Cory Elementary in Southeast Denver at Chestnut Ridge, offering a family-friendly community and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-merrill-middle-school-denver-county",
      "search_query": "apartments near Merrill Middle School Denver County",
      "category": "School",
      "h1_title": "Apartments Near Merrill Middle School",
      "h2_subtitle": "Explore Chestnut Ridge Apartments, ideally situated near Merrill Middle School in Denver County.",
      "page_copy": "Chestnut Ridge Apartment Homes offers an unbeatable location for families seeking proximity to Merrill Middle School in Denver County. Our spacious apartments, available in studio, one, and two-bedroom layouts, boast modern features like stainless steel appliances and private patios, enhancing everyday living with comfort and style.\n\nResidents of Chestnut Ridge enjoy a host of amenities, including a resort-style pool and a 24-hour fitness center, perfect for blending relaxation and activity. The community's location in Southeast Denver places you within easy reach of leading schools, shopping, and dining options, ensuring that everything you need is just moments away. Experience the convenience and charm of living near Merrill Middle School by making Chestnut Ridge your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Merrill Middle School, Denver County",
      "seo_description": "Discover apartments near Merrill Middle School in Denver County at Chestnut Ridge, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-close-to-denver-south-high-80237",
      "search_query": "apartments close to Denver South High School 80237",
      "category": "School",
      "h1_title": "Apartments Close to Denver South High School",
      "h2_subtitle": "Discover Chestnut Ridge Apartments, conveniently located close to Denver South High School in the 80237 area.",
      "page_copy": "Chestnut Ridge Apartment Homes are thoughtfully positioned for convenient living, just a short distance from Denver South High School in the 80237 zip code area. Choose from our selection of studio, one, and two-bedroom apartments, each offering premium amenities like stainless steel appliances and scenic private patios.\n\nResidents at Chestnut Ridge enjoy a vibrant lifestyle with access to a luxurious resort-style pool and a state-of-the-art 24-hour gym. Our community's prime location in Southeast Denver places you near educational institutions, shopping hubs, and recreational facilities, enriching your daily experience. Experience seamless living and exceptional community benefits at Chestnut Ridge, where proximity to top-rated schools meets modern comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Denver South High School 80237",
      "seo_description": "Find modern apartments near Denver South High School in the 80237 area at Chestnut Ridge, featuring top amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-asbury-elementary-school-denver-co",
      "search_query": "apartments near Asbury Elementary School Denver CO",
      "category": "School",
      "h1_title": "Apartments Near Asbury Elementary School",
      "h2_subtitle": "Explore Chestnut Ridge Apartments, ideally situated near Asbury Elementary School in Denver, CO.",
      "page_copy": "Chestnut Ridge Apartment Homes offers an exceptional location for families, just steps away from Asbury Elementary School in Denver, CO. Our community features a variety of floor plans, including studio, one, and two-bedroom apartments, equipped with stainless steel appliances and elegant wood floors.\n\nResidents enjoy a welcoming environment with a resort-style pool and a fully-equipped 24-hour gym at their disposal. Located in the vibrant Southeast Denver area, Chestnut Ridge provides easy access to top-rated schools, dining, and shopping venues. Experience the perfect mix of local convenience and modern amenities in a community designed to fit your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Asbury Elementary School, Denver CO",
      "seo_description": "Discover apartments near Asbury Elementary School in Denver, CO at Chestnut Ridge, offering modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-denver-academy-southeast-denver",
      "search_query": "apartments near Denver Academy Southeast Denver",
      "category": "School",
      "h1_title": "Apartments Near Denver Academy",
      "h2_subtitle": "Discover spacious living at Chestnut Ridge Apartments near Denver Academy in Southeast Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes provides an ideal living experience for those seeking proximity to Denver Academy in Southeast Denver. Our diverse selection of studio, one, and two-bedroom apartments are designed with modern living in mind, featuring high-end stainless steel appliances and private patios that offer stunning views.\n\nResidents enjoy an array of amenities, including a resort-style swimming pool and a comprehensive 24-hour fitness center, fostering an active and social lifestyle. Nestled in a prime Southeast Denver location, Chestnut Ridge offers easy access to educational institutions, dining, and shopping, making it a perfect choice for families and professionals alike. Experience the convenience and comfort of living near Denver Academy with everything Chestnut Ridge has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denver Academy, Southeast Denver",
      "seo_description": "Find modern apartments near Denver Academy in Southeast Denver at Chestnut Ridge, offering premium amenities and an engaging community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-hca-healthone-swedish-southeast-denver",
      "search_query": "apartments near HCA HealthONE Swedish Southeast Denver",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA HealthONE Swedish",
      "h2_subtitle": "Explore convenient living at Chestnut Ridge, near HCA HealthONE Swedish in Southeast Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes offers prime accommodations near HCA HealthONE Swedish, situated in the vibrant Southeast Denver area. Choose from a range of studio, one, and two-bedroom apartments, each equipped with modern stainless steel appliances and offering magnificent views from private patios.\n\nResidents can indulge in a luxurious lifestyle with access to a resort-style pool and a comprehensive 24-hour gym. Perfectly positioned in Southeast Denver, our community ensures easy access to healthcare facilities, shopping, dining, and entertainment. Experience the harmonious blend of comfort, convenience, and community at Chestnut Ridge, where proximity to leading healthcare centers like HCA HealthONE Swedish is just one of many benefits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA HealthONE Swedish, Southeast Denver",
      "seo_description": "Find comfortable apartments near HCA HealthONE Swedish in Southeast Denver at Chestnut Ridge, featuring top-tier amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-hampden-run-park-denver",
      "search_query": "apartments near Hampden Run Park Denver",
      "category": "Park",
      "h1_title": "Apartments Near Hampden Run Park",
      "h2_subtitle": "Discover Chestnut Ridge Apartments, ideally located near Hampden Run Park in Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes provides an inviting living environment, just a short distance from Hampden Run Park in Denver. Our community offers a choice of studio, one, and two-bedroom apartments, complete with modern stainless steel appliances and private patios that boast beautiful views.\n\nResidents at Chestnut Ridge can enjoy our resort-style pool and stay active in the fully-equipped 24-hour gym. Located in the lively Southeast Denver area, our apartments not only offer easy access to green spaces like Hampden Run Park but also an array of shopping and dining options. Embrace the convenience and vibrant lifestyle that Chestnut Ridge has to offer, all while being near the serene Hampden Run Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hampden Run Park, Denver",
      "seo_description": "Explore modern living at Chestnut Ridge, with apartments near Hampden Run Park in Denver, offering top-tier amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "horseshoe-park-adjacent-apartments-80237",
      "search_query": "Horseshoe Park adjacent apartments 80237",
      "category": "Park",
      "h1_title": "Horseshoe Park Adjacent Apartments",
      "h2_subtitle": "Experience exceptional living at Chestnut Ridge, adjacent to Horseshoe Park in the 80237 area.",
      "page_copy": "Chestnut Ridge Apartment Homes offers a unique blend of comfort and convenience, just steps away from Horseshoe Park in Denver's 80237 area. Our selection of studio, one, and two-bedroom apartments features stainless steel appliances, wood flooring, and private patios perfect for enjoying the scenic environment.\n\nResidents benefit from a variety of amenities including a resort-style swimming pool, a modern 24-hour fitness center, and a welcoming clubhouse. Located adjacent to Horseshoe Park, Chestnut Ridge not only provides easy access to recreational facilities but also offers proximity to shopping, dining, and entertainment in Southeast Denver. Discover a perfect balance of nature and urban living at Chestnut Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Horseshoe Park Adjacent Apartments, Denver",
      "seo_description": "Find modern apartments at Chestnut Ridge, adjacent to Horseshoe Park in Denver 80237, offering premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "horizon-park-nearby-apartments-southeast-denver",
      "search_query": "Horizon Park nearby apartments southeast Denver",
      "category": "Park",
      "h1_title": "Apartments Near Horizon Park",
      "h2_subtitle": "Live close to Horizon Park at Chestnut Ridge, offering exceptional apartments in Southeast Denver.",
      "page_copy": "Discover the vibrant lifestyle at Chestnut Ridge Apartment Homes, ideally located near Horizon Park in Southeast Denver. Our community offers beautifully designed studio, one, and two-bedroom apartments featuring modern amenities such as stainless steel appliances and private patios that overlook scenic views.\n\nEnjoy the luxury of a resort-style pool, a state-of-the-art 24-hour gym, and a stylish clubhouse. With Horizon Park just a stone's throw away, outdoor enthusiasts will appreciate the ample green space and recreational options. Experience the perfect blend of urban convenience and serene parkland at Chestnut Ridge, where Southeast Denver's best offerings are at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Horizon Park, Southeast Denver",
      "seo_description": "Explore Chestnut Ridge in Southeast Denver for stylish apartments near Horizon Park, complete with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-grandview-dog-park-denver",
      "search_query": "dog-friendly apartments close to Grandview Dog Park in Denver",
      "category": "Park",
      "h1_title": "Dog-Friendly Apartments Near Grandview",
      "h2_subtitle": "Chestnut Ridge offers dog-friendly living close to Grandview Dog Park in Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes is your perfect pet-friendly haven, ideally located near Grandview Dog Park in Denver. Our community welcomes you and your furry friends, offering spacious studio, one, and two-bedroom apartments equipped with modern amenities like stainless steel appliances and wood flooring.\n\nEnjoy the convenience of nearby Grandview Dog Park, providing plenty of space for your dog to play and socialize. At Chestnut Ridge, you can relax with your pet on your private patio or take advantage of our resort-style pool and 24-hour fitness center. Embrace a vibrant and pet-friendly lifestyle at Chestnut Ridge, just minutes from Denver's best natural spaces and amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Grandview Park",
      "seo_description": "Live at Chestnut Ridge, offering dog-friendly apartments near Grandview Dog Park, Denver. Enjoy pet-friendly amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "denver-county-apartments-plains-conservation-center",
      "search_query": "Denver County apartments by Plains Conservation Center",
      "category": "Park",
      "h1_title": "Apartments Near Plains Conservation Center",
      "h2_subtitle": "Discover Chestnut Ridge, located near the Plains Conservation Center in Denver County.",
      "page_copy": "Located in the heart of Denver County, Chestnut Ridge Apartment Homes offers an ideal living experience near the Plains Conservation Center. Choose from our modern studio, one, and two-bedroom apartments, each equipped with premium features like stainless steel appliances and stylish wood flooring.\n\nResidents enjoy easy access to the natural beauty of the Plains Conservation Center, making it a perfect spot for nature lovers and outdoor enthusiasts. After a day of exploring the nearby natural trails, unwind at our resort-style pool or keep fit at the 24-hour gym. Experience the blend of city convenience and serene landscapes at Chestnut Ridge, perfectly situated to enjoy both urban and natural attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Plains Conservation Center, Denver",
      "seo_description": "Explore Chestnut Ridge Apartments in Denver County, close to the Plains Conservation Center, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "sunburst-park-area-apartments-denver-co",
      "search_query": "Sunburst Park area apartments in Denver CO",
      "category": "Park",
      "h1_title": "Apartments Near Sunburst Park, Denver",
      "h2_subtitle": "Explore Chestnut Ridge, conveniently located near Sunburst Park in Denver, CO.",
      "page_copy": "Welcome to Chestnut Ridge Apartment Homes, perfectly situated in Denver near the vibrant Sunburst Park. Our community offers a selection of studio, one, and two-bedroom apartments, featuring upscale amenities such as stainless steel appliances and private patios with breathtaking views.\n\nEnjoy the proximity to Sunburst Park, where relaxation and recreational activities are just a few steps away. Chestnut Ridge enriches your lifestyle with a resort-style pool, a 24-hour gym, and a chic clubhouse designed for resident gatherings. Experience the ideal combination of urban convenience and peaceful parkland at Chestnut Ridge, making it a desirable place to call home in Denver, CO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunburst Park, Denver CO",
      "seo_description": "Live at Chestnut Ridge, offering modern apartments in Denver, CO, near Sunburst Park. Enjoy premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-mission-viejo-park-denver-80237",
      "search_query": "apartments near Mission Viejo Park Denver 80237",
      "category": "Park",
      "h1_title": "Apartments by Mission Viejo Park",
      "h2_subtitle": "Discover Chestnut Ridge, conveniently located near Mission Viejo Park in Denver, 80237.",
      "page_copy": "Chestnut Ridge Apartment Homes stands as a premier living destination near Mission Viejo Park in Denver, 80237. Our sophisticated studio, one, and two-bedroom apartments are tailored to fit a modern lifestyle, featuring sleek stainless steel appliances, elegant wood flooring, and private patios with scenic views.\n\nBeing close to Mission Viejo Park, residents can take advantage of the beautiful outdoor spaces, perfect for relaxation or recreational activities. Enjoy the best of both worlds at Chestnut Ridge with luxurious on-site amenities, including a resort-style pool, a state-of-the-art fitness center, and a welcoming clubhouse. Embrace a balanced lifestyle of convenience and leisure at this prime Denver location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mission Viejo Park, Denver 80237",
      "seo_description": "Find your home at Chestnut Ridge Apartments near Mission Viejo Park, Denver 80237. Experience modern living with convenient access to local parks and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "jewell-wetlands-park-proximity-apartments-southeast-denver",
      "search_query": "Jewell Wetlands Park proximity apartments in southeast Denver",
      "category": "Park",
      "h1_title": "Apartments Near Jewell Wetlands Park",
      "h2_subtitle": "Explore Chestnut Ridge, ideally located near Jewell Wetlands Park in Southeast Denver.",
      "page_copy": "Chestnut Ridge Apartment Homes offers a remarkable living experience close to Jewell Wetlands Park in Southeast Denver. Our stylish studio, one, and two-bedroom apartments boast modern amenities like stainless steel appliances and stunning wood floors, creating an inviting and contemporary atmosphere.\n\nWith Jewell Wetlands Park just a short distance away, our residents can enjoy the serene natural environment and the park's rich wildlife habitat. After a leisurely day in the park, return home to relax by the resort-style pool or stay active in our well-equipped 24-hour gym. Chestnut Ridge combines urban comfort with the tranquility of nature, making it the perfect place to call home in Southeast Denver.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jewell Wetlands Park, Southeast Denver",
      "seo_description": "Discover Chestnut Ridge, offering modern apartments near Jewell Wetlands Park in Southeast Denver, complemented by luxury amenities and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-belleview-station-denver",
      "search_query": "apartments near Belleview Station Denver",
      "category": "Transit",
      "h1_title": "Apartments Near Belleview Station",
      "h2_subtitle": "Enjoy vibrant living at Chestnut Ridge, located near Belleview Station in Denver.",
      "page_copy": "Discover Chestnut Ridge Apartment Homes, a thriving community just moments away from Belleview Station in Denver. Offering studio, one, and two-bedroom apartments, our residences are designed with sophisticated finishes such as stainless steel appliances and elegant wood flooring, ensuring your home exudes style and comfort.\n\nBelleview Station's proximity means easy access to an array of dining, shopping, and transportation options, simplifying urban living. Residents at Chestnut Ridge enjoy luxurious amenities like a resort-style pool, a comprehensive gym open 24 hours, and an inviting clubhouse ideal for social gatherings. Choose Chestnut Ridge and embrace a lifestyle intertwined with convenience and engagement in Denver.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleview Station Denver",
      "seo_description": "Discover Chestnut Ridge Apartments near Belleview Station, Denver. Experience luxury living with city life's convenience and top amenities at your door.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "chestnut-ridge-apartments-close-to-orchard-station",
      "search_query": "Chestnut Ridge apartments close to Orchard Station",
      "category": "Transit",
      "h1_title": "Chestnut Ridge Near Orchard Station",
      "h2_subtitle": "Convenience is key at Chestnut Ridge, located close to Orchard Station in Denver.",
      "page_copy": "At Chestnut Ridge Apartment Homes, experience the ideal blend of contemporary living and commuter convenience, closely situated to Orchard Station. Our studio, one, and two-bedroom apartments feature modern amenities like sleek stainless steel appliances and rich wood floors, creating an inviting home atmosphere.\n\nBeing in proximity to Orchard Station offers effortless access to public transit, making daily commutes or weekend explorations throughout Denver a breeze. Chestnut Ridge is not just about location; enjoy top-tier amenities, including a resort-inspired pool, a fully-equipped 24-hour fitness center, and a chic clubhouse. Make Chestnut Ridge your home and enjoy unparalleled comfort and convenience near Orchard Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chestnut Ridge Apartments Near Orchard Station",
      "seo_description": "Find Chestnut Ridge Apartments close to Orchard Station in Denver. Enjoy modern living with easy transit access and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166924",
      "source": "generator",
      "page_item_url": "apartments-near-denver-international-airport-co",
      "search_query": "apartments near Denver International Airport CO",
      "category": "Transit",
      "h1_title": "Apartments Near Denver Intl Airport",
      "h2_subtitle": "Chestnut Ridge offers convenient living near Denver International Airport, CO, perfect for frequent flyers.",
      "page_copy": "Chestnut Ridge Apartment Homes provide an ideal living experience for those frequently traveling, as they are strategically located near Denver International Airport, CO. Our community offers a selection of studio, one, and two-bedroom apartments equipped with upscale touches like stainless steel appliances and wood flooring.\n\nThe proximity to Denver International Airport ensures hassle-free travel options, making Chestnut Ridge perfect for those who value both comfort and accessibility. Beyond location, enjoy premium amenities such as a resort-style swimming pool, a comprehensive gym open around-the-clock, and a vibrant clubhouse for social connections. Choose Chestnut Ridge for a lifestyle that caters to both urban convenience and leisure travel.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees under a blue sky with clouds.",
        "public_id": "019d02d2-cc59-75ca-a008-9a80dde39608",
        "storage_key": "property/6767906449166924/019d02d2-cc59-75ca-a008-9a80dde39608.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denver International Airport CO",
      "seo_description": "Discover Chestnut Ridge, offering modern apartments near Denver International Airport, CO. Convenient travel access and luxury amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5736"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18381046085"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NLFHZ7KC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1124CHNT"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('aGXht7qWqcp9t8JeCf')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "44672433840"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/10pdq0xmw2z"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Chestnut_Ridge_Apartments/scheduletourwidget/hoHTwBCSs7Fr4lhvbH/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNYa2NCQWpjMkh0ZEdtVyt3SnYzcHc9PSIsInZhbHVlIjoicTZNOXZQKzdCTWtFMERodFNLeTE4Zz09IiwibWFjIjoiYTkxNzFkZGJmNmNmMWFkMGNkNTU2ODY1MDY2ZDg5ZjZmNDc4M2NjZmI5NWQzMjlmYzg0ZTczZDNiYjIzMTAzNCJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "5736",
  "custom_repli_id": "18381046085",
  "custom_google_gtm_id": "GTM-NLFHZ7KC",
  "custom_rollout_phase": "Pathfinder 3",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "1124CHNT",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('aGXht7qWqcp9t8JeCf')</script>",
  "custom_hubspot_company_id": "44672433840",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/10pdq0xmw2z",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "ER100107678",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Chestnut_Ridge_Apartments/scheduletourwidget/hoHTwBCSs7Fr4lhvbH/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNYa2NCQWpjMkh0ZEdtVyt3SnYzcHc9PSIsInZhbHVlIjoicTZNOXZQKzdCTWtFMERodFNLeTE4Zz09IiwibWFjIjoiYTkxNzFkZGJmNmNmMWFkMGNkNTU2ODY1MDY2ZDg5ZjZmNDc4M2NjZmI5NWQzMjlmYzg0ZTczZDNiYjIzMTAzNCJ9",
  "custom_audioeye_site_id": "3809bafd-6e71-477e-9f88-e775c51961e9",
  "custom_audioeye_site_hash": "594daac7a58a8310a3ca8d4c4fd92aea"
};

export const generatedAt = '2026-10-08T22:13:25.773Z';
